(function () {
  'use strict';

  // EV-C5 W3: read contract globals (api-contract.js must load before this script)
  var _contract = window.HPQApiContract || {};
  var CONTRACT_VERSION = _contract.CONTRACT_VERSION || '1.0.0';
  var ENDPOINTS = _contract.ENDPOINTS || [];
  var isValidEnvelope = _contract.isValidEnvelope || function (r) {
    return typeof r === 'object' && r !== null && 'ok' in r && 'customerIdentity' in r;
  };
  var contractMajorVersion = _contract.contractMajorVersion || function () {
    return parseInt(CONTRACT_VERSION.split('.')[0], 10);
  };
  var HPQ_ID_CACHE_KEY = 'hpq_id_v' + contractMajorVersion();

  // EV-C5 W3: validate that a worker response conforms to FortuneEnvelope.
  // /reading returns ReadingResponse (not FortuneEnvelope) — pass through without check.
  // On mismatch: warn + 1%-sampled beacon; never throws; always returns the response.
  function parseFortuneResponse(response, endpointPath) {
    if (endpointPath === '/reading') {
      return response;
    }
    if (!isValidEnvelope(response)) {
      console.warn('[HPQ] Contract shape mismatch on', endpointPath, response);
      if (Math.random() < 0.01) {
        try {
          fetch(FORTUNE_API_BASE + '/admin/contract-violation', {
            method: 'POST',
            body: JSON.stringify({ path: endpointPath, shape: Object.keys(response || {}) }),
            keepalive: true
          });
        } catch (e) {}
      }
    }
    return response;
  }

  var STAGING_TURNSTILE_SITEKEY = '0x4AAAAAADDQzJWlI28H1oHc';
  (function () {
    var params = new URLSearchParams(window.location.search);
    var devParam = params.get('hpq_fortune_dev');
    if (devParam === '1') {
      localStorage.setItem('hpq_fortune_use_dev_worker', '1');
      console.warn('[HPQ-FORTUNE] dev-worker mode ENABLED via ?hpq_fortune_dev=1');
    } else if (devParam === '0') {
      localStorage.removeItem('hpq_fortune_use_dev_worker');
      console.warn('[HPQ-FORTUNE] dev-worker mode DISABLED via ?hpq_fortune_dev=0');
    }
    var host = (window.location && window.location.hostname) || '';
    if (localStorage.getItem('hpq_fortune_use_dev_worker') === '1' || host === 'hpq-staging.myshopify.com') {
      window.HPQ_FORTUNE_USE_DEV_WORKER = true;
      window.HPQ_FORTUNE_TURNSTILE_SITE_KEY = STAGING_TURNSTILE_SITEKEY;
    }
  })();
  var CAA_SCOPE = 'openid email customer-account-api:full';
  var FORTUNE_API_BASE = (function () {
    var h = (window.location && window.location.hostname) || '';
    if ((h === 'localhost' || h === '127.0.0.1') && window.HPQ_FORTUNE_USE_DEV_WORKER === true) {
      return 'https://hpq-fortune-staging.pelian.workers.dev';
    }
    if (h === 'hpq-staging.myshopify.com' || h === 'hpq-dev.pelian.com' || h.endsWith('.shopifypreview.com')) {
      return 'https://hpq-fortune-staging.pelian.workers.dev';
    }
    return 'https://fortune.hotpotqueen.com';
  })();
  var HPQ_API_VERSION = 3;
  var LS_KEY = 'hpq_fortune_session';
  var MODAL_STATE_KEY = 'hpq_fortune_modal_state';
  var caa = window.HPQCustomerAccountAPI || {};
  var currentCustomer = null;
  var _fortuneController = null;
  var AUNTIE_COPY = {
    turnstile_failed: 'Auntie thinks you might be a bot. Refresh and try again.',
    bot_detected: 'Auntie thinks you might be a bot. Refresh and try again.',
    confirm_failed: "Auntie couldn't lock in your number. Try again.",
    rate_limited: 'Easy. She can only answer so many at once. Come back in a minute.',
    try_again: 'Auntie is busy with another reading. Try again in a moment.',
    in_progress: 'Auntie is mid-pour. Try again in a moment.',
    shopify_failed: 'The discount machine is stuck. Try again in a minute.',
    no_active_reward: 'No active code for this email. Shake for a new one.',
    expired: 'That code already expired. Shake for a new one.',
    delivery_failed: 'Auntie could not send just now. Try again.',
    caa_token_required: "Auntie's lost track of you. Sign in again to claim your code.",
    tier_mismatch: 'Auntie noticed your offer changed. Refresh and try again.',
    missing_acknowledged_tier: 'Something got dropped on the way. Refresh and try again.',
    identity_fetch_failed: "Auntie can't pull your file right now. Try again in a minute.",
    no_email: 'Auntie needs your email to send the zodiac reading. Add one to your account first.',
    no_birthdate: 'Auntie needs your birthday before she can read your zodiac. Tell her below.',
    suppression_check_failed: "Auntie can't check her list right now. Try again in a minute.",
    suppressed: "Auntie can't deliver to that email. Update it in your account and try again.",
    send_failed: "Auntie couldn't send that reading. Try again in a minute.",
    phone_taken: 'Looks like that number is already on another account. Try a different one.',
    phone_invalid: "Auntie can't read that number. Check the digits and try again.",
    phone_update_failed: "Auntie couldn't save that number just now. Try again.",
    mint_failed: "Auntie's discount machine hiccuped. Give her a second and try again.",
    invalid_phone: "Auntie can't read that number. Check the digits and try again.",
    consent_not_shown: "Auntie's having a moment. Try her again in a sec.",
    generic_failure: "Auntie's having a moment. Try her again in a sec.",
    skip_failed: "Auntie didn't catch that. Tap skip again.",
    declined: "You told Auntie 'no thanks' on texts. That's locked in — you'll still get your coupon, just no SMS.",
    already_declined: "You already told Auntie no. She's not going to ask again.",
    phone_lookup_failed: "Auntie can't reach the kitchen right now. Try again in a minute.",
    phone_unavailable: 'Looks like that number is already on another account. Try a different one.',
    otp_invalid: "That code doesn't look right. Try again.",
    otp_expired: 'That code expired. Tap Resend code for a new one.',
    otp_superseded: 'A new code was sent — please enter the latest code.',
    otp_invalid_format: 'Enter the 6-digit code.',
    twilio_send_failed: 'Auntie could not send just now. Try again.',
    twilio_check_failed: 'Auntie could not check that code just now. Try again.',
    admin_write_failed: "Auntie couldn't save that number just now. Try again.",
    code_reveal_pending_error_heading: 'Auntie fumbled that one.',
    unreachable: "Auntie can't reach the kitchen right now. Try again in a minute.",
  };
  function getCurrentCustomer() { return currentCustomer; }
  function setCurrentCustomer(customer) {
    currentCustomer = customer || null;
  }
  function getCachedTokensSafe() {
    try { return caa.getCachedTokens ? caa.getCachedTokens() : null; } catch (e) { return null; }
  }
  function clearTokensSafe() {
    try { if (caa.clearTokens) caa.clearTokens(); } catch (e) {}
  }
  // Clear the active session but KEEP the refresh_token — for transient, non-auth
  // recovery paths (customer-fetch blip, recognize bounce, cancelled login).
  // Deliberately does NOT fall back to caa.clearTokens: that helper deletes the
  // refresh token, so degrading from a safe operation to a destructive one
  // would log every shopper out during a CDN cache window where this new
  // footer is paired with an older cached hpq-customer-account-api.js that
  // predates clearSession — exactly the deploy of a change whose purpose is
  // to stop that. The version-agnostic fallback removes ONLY the
  // session/token blob, leaving the refresh token intact for a later retry.
  function clearSessionSafe() {
    try {
      if (caa.clearSession) {
        caa.clearSession();
      } else {
        // Direct storage removal — equivalent to clearSession's effect on
        // persisted state, and version-agnostic to the API module. Does
        // not touch the refresh token. Never falls through to
        // caa.clearTokens.
        try { window.localStorage.removeItem('hpq_caa_tokens'); } catch (e) {}
      }
    } catch (e) {}
  }
  // Shop domain for CAA calls — mirrors FortuneController.getShopDomain so the
  // refresh call hits the same discovery cache the login used.
  function caaShopDomain() {
    var h = ((window.location && window.location.hostname) || '').replace(/^www\./, '');
    if (h === 'localhost' || h === '127.0.0.1' || h === 'hpq-dev.pelian.com') return 'hpq-staging.myshopify.com';
    if (h === 'hpq-staging.myshopify.com') return h;
    if (h === 'hotpotqueen.com' || h === 'hotpotqueen.myshopify.com') return 'hotpotqueen.myshopify.com';
    return h;
  }
  // Attempt a silent token refresh (refresh_token grant). Resolves:
  //   'ok'        — fresh tokens minted (retry the request)
  //   'transient' — refresh temporarily unavailable (5xx/429/network/discovery);
  //                 the session is INTACT, so surface a soft failure and keep
  //                 tokens for a later retry
  //   'terminal'  — only known-terminal reasons; force re-auth
  //
  // Default-transient mapping: a reason string we do not explicitly recognise
  // is NOT evidence the credential is dead. A network `TypeError` from the
  // refresh POST produces err.message "Failed to fetch"; a discovery failure
  // produces "discovery_failed" / "invalid_discovery". Under the old
  // whitelist-only-transient model those mismatched reasons fell through to
  // 'terminal' → forceReAuth → clearTokensSafe → permanent logout. Treat
  // only those reasons the caller has proven terminal as terminal:
  //   - no_refresh_token : nothing stored, must re-auth
  //   - refresh_failed   : server rejected the grant (parsed invalid_grant)
  // Everything else is transient: a transient refresh failure during a
  // network flake on a different host from the worker that just answered
  // must not log out the shopper for the remainder of the session.
  function refreshCaaTokens() {
    try {
      if (!caa.refreshAccessToken || !caa.getStoredRefreshToken || !caa.getStoredRefreshToken()) return Promise.resolve('terminal');
      var clientId = window.HPQ_CAA_CLIENT_ID;
      if (!clientId) return Promise.resolve('terminal');
      return caa.refreshAccessToken({ shopDomain: caaShopDomain(), clientId: clientId })
        .then(function (r) {
          if (r && r.ok) return 'ok';
          if (r && r.reason === 'refresh_failed') return 'terminal';
          // Default-transient: refresh_transient, refresh_error, network-
          // path strings ('Failed to fetch'), discovery-path strings
          // ('discovery_failed', 'invalid_discovery'), and any future
          // reason we don't yet recognise all keep the session alive.
          return 'transient';
        })
        .catch(function () { return 'transient'; });
    } catch (e) { return Promise.resolve('transient'); }
  }
  // Soft failure that does NOT clear the session — used when a refresh is only
  // temporarily unavailable, so the refresh token survives for a later retry.
  function authRetryLater(code) {
    return { ok: false, customerIdentity: null, reason: code, message: AUNTIE_COPY.unreachable };
  }
  // Give up on the CAA session and signal the caller to render the sign-in pane.
  function forceReAuth(code, source) {
    clearTokensSafe();
    setCurrentCustomer(null);
    try { emit('hpq:auth-state-changed', { trigger: code, source: source }); } catch (e) {}
    return { ok: false, customerIdentity: null, reason: code, shouldReAuth: true, message: AUNTIE_COPY.caa_token_required };
  }
  function generateIdempotencyNonceSafe() {
    if (!caa.generateIdempotencyNonce) throw new Error('idempotency_unavailable');
    return caa.generateIdempotencyNonce();
  }

  // libphonenumber wrapper (hpq-iti-utils.js is an ES module that default-exports
  // the utils object — formatNumberAsYouType, formatNumber, isValidNumber, etc).
  // Lazy-loaded on first phone_capture render; cached as a resolved Promise.
  var _phoneUtilsPromise = null;
  function getPhoneUtils() {
    if (_phoneUtilsPromise) return _phoneUtilsPromise;
    var url = window.HPQ_FORTUNE_ITI_UTILS_URL;
    if (!url) {
      _phoneUtilsPromise = Promise.resolve(null);
      return _phoneUtilsPromise;
    }
    _phoneUtilsPromise = import(url)
      .then(function (mod) { return (mod && mod.default) || null; })
      .catch(function () { return null; });
    return _phoneUtilsPromise;
  }
  function errorToAuntieCopy(errorCode) {
    return AUNTIE_COPY[errorCode] || AUNTIE_COPY.generic_failure;
  }
  function parseBody(res, rawText) {
    try { return JSON.parse(rawText); } catch (e) { return null; }
  }
  function delay(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
  function authHeaders(headers) {
    var out = {};
    var source = headers || {};
    Object.keys(source).forEach(function (k) { out[k] = source[k]; });
    var tokens = getCachedTokensSafe();
    // X-CAA-Access-Token is the ONLY credential. Phase 3 deleted the worker's
    // id_token path, so sending Authorization: Bearer would be sending a header
    // nothing reads.
    //
    // The id_token is NOT dead — it is still required as id_token_hint for OIDC
    // logout — it is simply no longer an authentication credential. Shopify
    // issues it at login only and never reissues it on the refresh grant, so it
    // was a stale cached claim standing in for a live authoritative answer, and
    // the worker had to carry guards to stop the two identities disagreeing.
    // One credential cannot disagree with itself.
    if (tokens && tokens.accessToken) out['X-CAA-Access-Token'] = tokens.accessToken;
    return out;
  }
  function cloneBody(body) {
    var out = {};
    var source = body || {};
    Object.keys(source).forEach(function (k) {
      if (source[k] !== undefined) out[k] = source[k];
    });
    return out;
  }


  // Retry behavior:
  // - 5xx with structured error body (any truthy `error` field) → return immediately, NO retry.
  // - 5xx with empty/unparseable body → retry once with a FRESH idempotency_nonce.
  // - `transient` field in response body is informational only; not consulted by client.
  function withFreshNonce(b) {
    if (b && typeof b === 'object' && typeof b.idempotency_nonce === 'string') {
      return Object.assign({}, b, { idempotency_nonce: generateIdempotencyNonceSafe() });
    }
    return b;
  }

  function apiFetch(path, body, _retries, _authRetries) {
    var retries = (_retries === undefined) ? 1 : _retries;
    // Auth (401 -> refresh) gets its OWN budget, independent of the 5xx/network
    // retry counter, so a transient 5xx that spends `retries` can't starve the
    // one silent-refresh attempt a subsequent 401 deserves.
    var authRetries = (_authRetries === undefined) ? 1 : _authRetries;
    var payload = cloneBody(body);
    var sentHeaders = authHeaders({ 'Content-Type': 'application/json' });
    // Capture whether this request actually carried a credential. A 401
    // against a request that sent NO credential means one of:
    //   (a) genuinely signed-out — nothing to refresh, short-circuit
    //   (b) signed-in but the access token looked dead to authHeaders
    //       (expired, no expiresAt, etc.) — the refresh ladder CAN recover
    //       because the refresh_token trades the stored refresh_token,
    //       NOT the access token. Conflating these two cases short-
    //       circuits on every mid-session recovery, forcing the shopper
    //       to a full page reload to get back in. Distinguish by checking
    //       whether a stored refresh_token exists.
    var sentCredential = !!(sentHeaders.Authorization || sentHeaders['X-CAA-Access-Token']);
    var hasStoredRefresh = !!(caa.getStoredRefreshToken && caa.getStoredRefreshToken());
    return fetch(FORTUNE_API_BASE + path, {
      method: 'POST',
      headers: sentHeaders,
      credentials: 'include',
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.text().then(function (rawText) {
        if (!res.ok) {
          if (res.status < 500) {
            var errBody = parseBody(res, rawText) || {};
            var code = errBody.reason || 'unknown';
            if (res.status === 401) {
              // A 401 means the credential was definitively rejected (or
              // absent). The worker sends two 401 reasons — caa_token_invalid
              // (auth layer, {"error","reason"}) and caa_token_required
              // (endpoint gate, {"ok":false,...}) — both arrive with
              // `reason` set, which is the ONLY field common to both
              // envelopes, so we branch on it and never on `error`.
              if (!sentCredential) {
                // The worker had nothing to check. If we have a stored
                // refresh_token AND we haven't yet attempted a silent
                // refresh this request, run one: the refresh_token grant
                // trades the refresh_token, NOT the access token, so an
                // expired-but-cached access token is recoverable even
                // when no header was sent. This is the R2 mid-session
                // recovery path; conflating it with a genuine signed-out
                // 401 short-circuits every recovery into a "Try again in
                // a minute" and forces a full page reload to get back in.
                if (authRetries > 0 && hasStoredRefresh) {
                  return refreshCaaTokens().then(function (state) {
                    if (state === 'ok') return apiFetch(path, withFreshNonce(body), retries, authRetries - 1);
                    if (state === 'transient') return authRetryLater(code); // keep session
                    return forceReAuth(code, 'apiFetch');
                  });
                }
                // No ladder material OR the ladder has already been
                // used this request — this is the loop guard. A second
                // ladder on the same request cannot succeed when the
                // first already either rotated the grant or used the
                // only one we had. Preserve the session.
                return authRetryLater(code);
              }
              // Credential was sent — a true rejection. One silent
              // refresh ladder attempt before forceReAuth.
              if (authRetries > 0) {
                return refreshCaaTokens().then(function (state) {
                  if (state === 'ok') return apiFetch(path, withFreshNonce(body), retries, authRetries - 1);
                  if (state === 'transient') return authRetryLater(code); // keep session
                  return forceReAuth(code, 'apiFetch');
                });
              }
              return forceReAuth(code, 'apiFetch');
            }
            // A 403 identity_mismatch is a HARD refusal (the two credentials
            // named different customers) — never clears tokens, never retries;
            // surface the reason as-is.
            return { ok: false, customerIdentity: null, reason: code, message: errorToAuntieCopy(code) };
          }
          // 5xx: parse body to distinguish structured state-machine errors from true infra glitches.
          // Structured error (server has state, retry will collide) -> return immediately, no retry.
          // Empty/unparseable body (true infra glitch) -> retry once with a FRESH nonce to avoid lock wedge.
          var fivexxBody = parseBody(res, rawText);
          if (fivexxBody && fivexxBody.reason) {
            // A 5xx with a structured reason (the worker's state-machine
            // error — {"error":"unavailable","reason":"caa_unavailable"}
            // or {"ok":false,...,"reason":"caa_unavailable"} — branch on
            // `reason`, never on `error`) means the Customer Account API
            // was unreachable and the credential was never CHECKED. The
            // session must stay INTACT: clearTokens() deletes the stored
            // refresh token, so a 30-second backend blip would otherwise
            // mass-log-out every shopper — the exact symptom this whole
            // effort exists to fix. (Comment said 503; the fix widens
            // this to any 5xx carrying a structured reason — a Cloudflare
            // 500 with a parseable body deserves the same session-
            // preserving handling.)
            if (res.status >= 500) {
              return authRetryLater(fivexxBody.reason);
            }
            return { ok: false, customerIdentity: null, reason: fivexxBody.reason, message: fivexxBody.message || errorToAuntieCopy(fivexxBody.reason) };
          }
          if (retries > 0) return delay(500).then(function () { return apiFetch(path, withFreshNonce(body), retries - 1, authRetries); });
          return { ok: false, customerIdentity: null, reason: 'unreachable', message: AUNTIE_COPY.unreachable };
        }
        var parsed = parseBody(res, rawText);
        if (!parsed) {
          if (retries > 0) return delay(500).then(function () { return apiFetch(path, withFreshNonce(body), retries - 1, authRetries); });
          return { ok: false, customerIdentity: null, reason: 'malformed', message: AUNTIE_COPY.unreachable };
        }
        return parseFortuneResponse(parsed, path);
      });
    }).catch(function () {
      // Network throw (no response): retry with fresh nonce — original request outcome is unknown.
      if (retries > 0) return delay(500).then(function () { return apiFetch(path, withFreshNonce(body), retries - 1, authRetries); });
      return { ok: false, customerIdentity: null, reason: 'unreachable', message: AUNTIE_COPY.unreachable };
    });
  }

  function apiGet(path, _headers, _retries, _authRetries) {
    var retries = (_retries === undefined) ? 1 : _retries;
    // 401 -> refresh gets its own budget, independent of the 5xx/network retry
    // counter (see apiFetch for rationale).
    var authRetries = (_authRetries === undefined) ? 1 : _authRetries;
    var headers = authHeaders(_headers || {});
    // Same two-state capture as apiFetch: a 401 against a request that
    // sent no credential AND has no stored refresh_token is a genuine
    // "you're not signed in" response (short-circuit). A no-credential
    // 401 with a stored refresh_token means the access token looked
    // dead to authHeaders — the refresh ladder can mint a fresh one
    // and the retried apiGet recomputes authHeaders with it. See
    // apiFetch for the full rationale.
    var sentCredential = !!(headers.Authorization || headers['X-CAA-Access-Token']);
    var hasStoredRefresh = !!(caa.getStoredRefreshToken && caa.getStoredRefreshToken());
    return fetch(FORTUNE_API_BASE + path, { credentials: 'include', headers: headers }).then(function (res) {
      return res.text().then(function (rawText) {
        if (!res.ok) {
          if (res.status < 500) {
            var errBody = parseBody(res, rawText) || {};
            var code = errBody.reason || 'unknown';
            if (res.status === 401) {
              // Same two-state guard as apiFetch — see the full rationale
              // there. The retried apiGet recomputes authHeaders with the
              // freshly minted token, which is the R2 mid-session
              // recovery path.
              if (!sentCredential) {
                if (authRetries > 0 && hasStoredRefresh) {
                  return refreshCaaTokens().then(function (state) {
                    if (state === 'ok') return apiGet(path, _headers, retries, authRetries - 1);
                    if (state === 'transient') return authRetryLater(code); // keep session
                    return forceReAuth(code, 'apiGet');
                  });
                }
                // No ladder material OR ladder already used — preserve session.
                return authRetryLater(code);
              }
              // Credential was sent — a true rejection. One silent
              // refresh ladder attempt before forceReAuth.
              if (authRetries > 0) {
                return refreshCaaTokens().then(function (state) {
                  if (state === 'ok') return apiGet(path, _headers, retries, authRetries - 1);
                  if (state === 'transient') return authRetryLater(code); // keep session
                  return forceReAuth(code, 'apiGet');
                });
              }
              return forceReAuth(code, 'apiGet');
            }
            // 403 identity_mismatch is a hard refusal — no token clearing, no
            // retry (see apiFetch).
            return { ok: false, customerIdentity: null, reason: code, message: errorToAuntieCopy(code) };
          }
          // 5xx: same structured-error gate as apiFetch — return immediately if server has state.
          // GETs carry no idempotency_nonce so no nonce regeneration needed on retry.
          var fivexxBody = parseBody(res, rawText);
          if (fivexxBody && fivexxBody.reason) {
            // Any 5xx with a structured reason is session-preserving
            // (CAA was unreachable, the credential unchecked) — never
            // force re-auth on one. See the apiFetch branch for the full
            // rationale and the two-envelope hazard. Widened from 503
            // so a Cloudflare 500 with a parseable caa_unavailable
            // body gets the same handling.
            if (res.status >= 500) {
              return authRetryLater(fivexxBody.reason);
            }
            return { ok: false, customerIdentity: null, reason: fivexxBody.reason, message: fivexxBody.message || errorToAuntieCopy(fivexxBody.reason) };
          }
          if (retries > 0) return delay(500).then(function () { return apiGet(path, headers, retries - 1, authRetries); });
          return { ok: false, customerIdentity: null, reason: 'unreachable', message: AUNTIE_COPY.unreachable };
        }
        var parsed = parseBody(res, rawText);
        if (!parsed) {
          if (retries > 0) return delay(500).then(function () { return apiGet(path, headers, retries - 1, authRetries); });
          return { ok: false, customerIdentity: null, reason: 'malformed', message: AUNTIE_COPY.unreachable };
        }
        return parseFortuneResponse(parsed, path);
      });
    }).catch(function () {
      if (retries > 0) return delay(500).then(function () { return apiGet(path, headers, retries - 1, authRetries); });
      return { ok: false, customerIdentity: null, reason: 'unreachable', message: AUNTIE_COPY.unreachable };
    });
  }

  var client = {
    shake: function () { return apiFetch('/shake', {}); },
    recognize: function () { return apiFetch('/recognize', {}); },
    tierUpgradeAck: function (acknowledgedTier) {
      return apiFetch('/tier-upgrade-ack', { acknowledged_tier: acknowledgedTier });
    }
  };

  function legacySessionKey() { return 'session' + '_id'; }

  function saveSession(data) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function migrateLocalStorageSchema(session) {
    if (!session) return null;
    if (session[legacySessionKey()] && session.has_active_state === undefined) {
      session.has_active_state = true;
    }
    delete session[legacySessionKey()];
    delete session.email_pending;
    delete session.resend_count;
    // Migrate legacy object birthdate { year, month, day, time_of_day } to string + time_of_day
    if (session.birthdate && typeof session.birthdate === 'object') {
      var bd = session.birthdate;
      if (bd.year && bd.month && bd.day) {
        session.birthdate =
          bd.year + '-' +
          (bd.month < 10 ? '0' : '') + bd.month + '-' +
          (bd.day   < 10 ? '0' : '') + bd.day;
        if (bd.time_of_day && !session.time_of_day) {
          session.time_of_day = bd.time_of_day;
        }
      } else {
        delete session.birthdate; // malformed legacy entry
      }
    }
    session.schema_version = 1;
    return session;
  }

  function loadSession() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return null;
      var session = migrateLocalStorageSchema(JSON.parse(raw));
      localStorage.setItem(LS_KEY, JSON.stringify(session));
      return session;
    } catch (e) { return null; }
  }

  function hasActiveState(session) {
    return !!(session && (session.has_active_state || session[legacySessionKey()]));
  }

  function normalizeRewardForReveal(reward, fallback) {
    var src = reward || {};
    var fb = fallback || {};
    var discount = src.discount !== undefined ? src.discount :
      (src.discount_pct !== undefined ? src.discount_pct :
        (fb.discount !== undefined ? fb.discount : fb.discount_pct));
    return {
      discount_code: src.discount_code || src.code || fb.discount_code || fb.code || '',
      discount: discount,
      tier: src.tier || src.tier_id || fb.tier || fb.tier_id || '',
      expires_at: src.expires_at || fb.expires_at || null
    };
  }

  function getRevealFortune(session, payload) {
    var fromPayload = normalizeRewardForReveal(payload, {});
    if (fromPayload.discount_code) return fromPayload;
    if (session && session.reward) {
      var fromReward = normalizeRewardForReveal(session.reward, session.fortune);
      if (fromReward.discount_code) return fromReward;
    }
    return normalizeRewardForReveal(session && session.fortune, {});
  }

  function discountDisplayForFortune(fortune) {
    var raw = fortune && fortune.discount;
    var parsed = parseInt(raw, 10);
    if (parsed) return String(parsed);
    return String(raw || '').replace(/%/g, '');
  }

  function normalizeFortuneLine(line) {
    if (!line) return { cn: '', en: '' };
    if (typeof line === 'string') return { cn: '', en: line };
    return {
      cn: line.cn || line.zh || line.chinese || '',
      en: line.en || line.english || line.text || ''
    };
  }

  function storeFortuneLineFromResponse(session, response, useShakeFallback) {
    if (!session || !response) return;
    var projection = response.serverProjection || {};
    var line = projection.fortune_line || response.fortune_line;
    var voice = projection.voice || response.voice;
    if (line) session.fortune_line = line;
    if (voice) session.voice = voice;
    if (!session.fortune_line && useShakeFallback) {
      session.fortune_line = {
        cn: '民以食为天',
        en: 'Food is heaven for the people'
      };
    }
  }

  function renderFortuneSlipHTML(session, useGenericFallback) {
    var line = normalizeFortuneLine(session && session.fortune_line);
    if (!line.cn && !line.en && session && session.voice) {
      line = normalizeFortuneLine(session.voice);
    }
    if (!line.cn && !line.en && useGenericFallback) {
      line = { cn: '民以食为天', en: 'Food is heaven for the people' };
    }

    var cn = line.cn ? '<p class="hpq-fortune-cookie__cn" lang="zh-Hans">' + escHTML(line.cn) + '</p>' : '';
    var en = line.en ? '<p class="hpq-fortune-cookie__en">' + escHTML(line.en) + '</p>' : '';

    return (
      '<div class="hpq-fortune-cookie hpq-fortune-cookie--slip" data-hpq-fortune-slip>' +
        '<div class="hpq-fortune-cookie__eyebrow">AUNTIE SEES YOU</div>' +
        cn +
        en +
      '</div>'
    );
  }

  function renderAnonCouponCTAHTML() {
    return (
      '<div class="hpq-fortune-footer__status" data-hpq-coupon-slot data-hpq-coupon-ready="0">' +
        '<p class="hpq-fortune-footer__heading">Want today\'s coupon?</p>' +
        '<p class="hpq-fortune-footer__body">Auntie has one for you. Come back and say hi.</p>' +
        '<button class="hpq-fortune-cta" data-action="claim-anon-coupon">Claim coupon</button>' +
        '<p class="hpq-fortune-footer__msg" aria-live="polite"></p>' +
      '</div>'
    );
  }

  function renderCouponRevealHTML(fortune, animateClass) {
    var discountDisplay = discountDisplayForFortune(fortune);
    var heading = discountDisplay
      ? 'Auntie gave you ' + discountDisplay + '% off today!'
      : 'Auntie saved a coupon for you.';

    return (
      '<div class="hpq-fortune-footer__coupon-slot' + (animateClass ? ' ' + animateClass : '') + '" data-hpq-coupon-slot data-hpq-coupon-ready="1">' +
        '<p class="hpq-fortune-footer__heading">' + escHTML(heading) + '</p>' +
        '<p class="hpq-fortune-footer__count-eyebrow">Coupon code expires in</p>' +
        '<div class="hpq-fortune-footer__countdown-wrap">' +
          '<div class="hpq-fortune-footer__countdown" data-role="countdown" role="timer" aria-live="off">' +
            '<span class="hpq-fortune-footer__count-group" aria-hidden="true">' +
              '<span class="hpq-fortune-footer__count-tile" data-role="hh1">0</span>' +
              '<span class="hpq-fortune-footer__count-tile" data-role="hh2">0</span>' +
            '</span>' +
            '<span class="hpq-fortune-footer__count-sep" aria-hidden="true">:</span>' +
            '<span class="hpq-fortune-footer__count-group" aria-hidden="true">' +
              '<span class="hpq-fortune-footer__count-tile" data-role="mm1">0</span>' +
              '<span class="hpq-fortune-footer__count-tile" data-role="mm2">0</span>' +
            '</span>' +
            '<span class="hpq-fortune-footer__count-sep" aria-hidden="true">:</span>' +
            '<span class="hpq-fortune-footer__count-group" aria-hidden="true">' +
              '<span class="hpq-fortune-footer__count-tile" data-role="ss1">0</span>' +
              '<span class="hpq-fortune-footer__count-tile" data-role="ss2">0</span>' +
            '</span>' +
            '<span class="hpq-sr-only" data-role="countdown-aria"></span>' +
          '</div>' +
        '</div>' +
        '<div class="hpq-fortune-footer__status">' +
          '<div class="hpq-fortune-footer__code-card">' +
            '<code class="hpq-fortune-footer__code" data-role="code"></code>' +
            '<button type="button" class="hpq-fortune-footer__copy-btn" data-role="copy-btn" aria-label="Copy discount code">' +
              '<span data-role="copy-label">Copy</span>' +
            '</button>' +
          '</div>' +
          '<button type="button" class="hpq-fortune-footer__apply-btn" data-role="apply-btn">Apply to my cart</button>' +
          '<p class="hpq-fortune-footer__msg" aria-live="polite"></p>' +
          '<p class="hpq-fortune-footer__legal">Expires at midnight PT. $20 minimum.</p>' +
          '<span class="hpq-sr-only" aria-live="assertive" data-role="announce"></span>' +
        '</div>' +
      '</div>'
    );
  }

  function ensureCouponAnimationStyles() {
    if (document.getElementById('hpq-coupon-animate-style')) return;
    var style = document.createElement('style');
    style.id = 'hpq-coupon-animate-style';
    style.textContent =
      '.hpq-coupon-animate-in{animation:hpq-coupon-animate-in 280ms ease-out both;}' +
      '@keyframes hpq-coupon-animate-in{from{opacity:0;transform:translateY(-8px);}to{opacity:1;transform:translateY(0);}}' +
      '@media (prefers-reduced-motion: reduce){.hpq-coupon-animate-in{animation:none!important;}}';
    document.head.appendChild(style);
  }

  function ensureLogoutPendingStyles() {
    if (document.getElementById('hpq-logout-pending-style')) return;
    var style = document.createElement('style');
    style.id = 'hpq-logout-pending-style';
    style.textContent =
      '.hpq-fortune--logging-out .hpq-fortune-footer__inner{opacity:.62;pointer-events:none;transition:opacity 160ms ease;}' +
      '.hpq-fortune--logging-out .hpq-fortune-cta,.hpq-fortune--logging-out .hpq-fortune-identity__notyou{cursor:wait;}';
    document.head.appendChild(style);
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }

  function getTurnstileToken() {
    var host = (window.location && window.location.hostname) || '';
    if (((host === 'localhost' || host === '127.0.0.1') && window.HPQ_FORTUNE_USE_DEV_WORKER === true) || host === 'hpq-dev.pelian.com') {
      return Promise.resolve('LOCALHOST-DEV-BYPASS');
    }
    return new Promise(function (resolve, reject) {
      var widgetId = _fortuneController && _fortuneController.turnstileWidgets &&
        _fortuneController.turnstileWidgets[_fortuneController.state];
      if (window.turnstile && widgetId) {
        var token = window.turnstile.getResponse(widgetId);
        if (token) return resolve(token);
        return reject(new Error('turnstile_token_expired'));
      }
      reject(new Error('turnstile_not_mounted'));
    });
  }

  var _turnstileLoaded = false;
  var _turnstileLoading = null;

  function loadTurnstile() {
    if (_turnstileLoaded) return Promise.resolve();
    if (_turnstileLoading) return _turnstileLoading;
    _turnstileLoading = new Promise(function (resolve) {
      if (window.turnstile) { _turnstileLoaded = true; resolve(); return; }
      var script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.onload = function () { _turnstileLoaded = true; resolve(); };
      script.onerror = function () { resolve(); };
      document.head.appendChild(script);
    });
    return _turnstileLoading;
  }

  function FortuneController(section) {
    this.section = section;
    this.inner = section.querySelector('.hpq-fortune-footer__inner') ||
      (section.querySelector('.hpq-fortune-footer__form') &&
        section.querySelector('.hpq-fortune-footer__form').parentElement) ||
      section;
    this.state = 'envelope_shake';
    this.session = { phone: null, email: null, has_active_state: false };
    this.transitionPayload = null;
    this.turnstileWidgets = {};
    this._history = [];
    this.init();
  }

  FortuneController.prototype.getShopDomain = function () {
    var h = ((window.location && window.location.hostname) || '').replace(/^www\./, '');
    if (h === 'localhost' || h === '127.0.0.1' || h === 'hpq-dev.pelian.com') return 'hpq-staging.myshopify.com';
    if (h === 'hpq-staging.myshopify.com') return h;
    if (h === 'hotpotqueen.com' || h === 'hotpotqueen.myshopify.com') return 'hotpotqueen.myshopify.com';
    return h;
  };

  FortuneController.prototype.getRedirectUri = function () {
    // Use canonical root URI from caa namespace. Pre-redirect, capture
    // current pathname+search to sessionStorage so we can restore the user's
    // intended page after the callback redirects back to /. Skip capture when
    // already on the callback URL — getRedirectUri is also called during
    // token exchange (search has code+state params); capturing then would
    // store a nonsense return-path that restoration would navigate to.
    try {
      var search = window.location.search || '';
      if (!/[?&]fortune_oauth_callback=1\b/.test(search)) {
        window.sessionStorage.setItem(
          'hpq:pkce-return-path',
          window.location.pathname + search
        );
      }
    } catch (e) {}
    return caa.buildCanonicalRedirectUri();
  };

  FortuneController.prototype.authOptions = function () {
    return {
      shopDomain: this.getShopDomain(),
      clientId: window.HPQ_CAA_CLIENT_ID || '',
      scope: CAA_SCOPE,
      redirectUri: this.getRedirectUri()
    };
  };

  FortuneController.prototype.cleanOAuthUrl = function () {
    try {
      var url = new URL(window.location.href);
      ['fortune_oauth_callback', 'code', 'state', 'error', 'error_description'].forEach(function (key) {
        url.searchParams.delete(key);
      });
      window.history.replaceState({}, document.title, url.pathname + (url.search ? url.search : '') + url.hash);
    } catch (e) {}
  };

  FortuneController.prototype.saveModalStateForRedirect = function () {
    try {
      sessionStorage.setItem(MODAL_STATE_KEY, JSON.stringify({
        session: this.session || {},
        state: this.state,
        saved_at: Date.now()
      }));
    } catch (e) {}
  };

  FortuneController.prototype.restoreModalState = function () {
    try {
      var raw = sessionStorage.getItem(MODAL_STATE_KEY);
      sessionStorage.removeItem(MODAL_STATE_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (saved && saved.session) this.session = migrateLocalStorageSchema(saved.session) || this.session;
      document.dispatchEvent(new CustomEvent('hpq:fortune-tab:open'));
    } catch (e) {}
  };

  FortuneController.prototype.pkceInterstitialHtml = function (subtitle) {
    return [
      '<div class="hpq-fortune-shake hpq-fortune-shake--redirecting" data-hpq-shake>',
      '  <div class="hpq-fortune-shake__eyebrow">Auntie’s getting your name from Shopify.</div>',
      '  <div class="hpq-fortune-shake__target hpq-fortune-shake__target--burst" data-hpq-shake-target>',
      '    <div class="hpq-fortune-shake__envelope">🧧</div>',
      '  </div>',
      '  <p class="hpq-fortune-shake__subtitle">' + (subtitle || 'One sec — opening the door.') + '</p>',
      '</div>'
    ].join('');
  };

  FortuneController.prototype.beginPkceFlow = function () {
    var self = this;
    if (!caa.startPkceFlow) {
      showMsg(this.inner, "Auntie can't pull your info right now. Give her a second.");
      return;
    }
    var clientId = window.HPQ_CAA_CLIENT_ID || '';
    if (!clientId) {
      showMsg(this.inner, "Auntie can't pull your info right now. Give her a second.");
      return;
    }

    // Desktop: interactive login in a popup window. The storefront — and this
    // open fortune modal — stays put underneath; on success we update in place
    // with no navigation, so no modal-state save/restore is needed. Mobile,
    // popup-blocked, and older browsers fall through to the full-page redirect.
    if (caa.startPkcePopupFlow && caa.isPopupLoginSupported && caa.isPopupLoginSupported()) {
      this.inner.innerHTML = this.pkceInterstitialHtml('Finish signing in in the window that just opened.');
      caa.startPkcePopupFlow({
        shopDomain: self.getShopDomain(),
        clientId: clientId,
        scope: CAA_SCOPE,
        redirectUri: caa.buildPopupRedirectUri()
      }).then(function (result) {
        if (result && result.ok && result.tokens) {
          caa.getCustomerFromTokens(result.tokens.idToken, result.tokens.accessToken, self.getShopDomain())
            .then(function (customer) {
              setCurrentCustomer(customer);
              self.transition('recognizing');
            })
            .catch(function (err) {
              try { console.warn('[HPQ-FORTUNE] popup token/customer failed', err); } catch (e) {}
              clearSessionSafe(); // transient customer-fetch failure — keep refresh token
              setCurrentCustomer(null);
              self.transition(self.preLoginFallbackState());
            });
          return;
        }
        // Popup blocked despite the synchronous open — fall back to redirect.
        if (result && result.reason === 'popup_blocked') {
          self.beginPkceRedirectFlow();
          return;
        }
        // Closed, timed out, or OAuth error: restore a usable pre-login state
        // instead of leaving the shopper on the stuck "opening the door" card.
        self.transition(self.preLoginFallbackState());
      });
      return;
    }

    this.beginPkceRedirectFlow();
  };

  FortuneController.prototype.beginPkceRedirectFlow = function () {
    var opts = this.authOptions();
    if (!opts.clientId) {
      showMsg(this.inner, "Auntie can't pull your info right now. Give her a second.");
      return;
    }
    this.saveModalStateForRedirect();
    this.inner.innerHTML = this.pkceInterstitialHtml('One sec — opening the door.');
    caa.startPkceFlow(opts);
  };

  FortuneController.prototype.preLoginFallbackState = function () {
    var sess = this.session || {};
    if (sess.fortune_line && !sess.customer_gid) return 'code_reveal';
    return 'envelope_shake';
  };

  FortuneController.prototype.init = function () {
    var self = this;
    var params = new URLSearchParams(window.location.search);
    // If this page is a login popup, hpq-silent-auth-init has already relayed the
    // code to the OPENER (which owns the single token exchange) and set this
    // in-memory flag. Do NOT exchange here or we would double-spend the
    // single-use auth code and break the opener's login. silent-auth-init runs
    // before this script, so the flag is set by the time init() runs.
    if (window.HPQ_POPUP_AUTH_RELAYED) {
      return;
    }
    if (params.get('fortune_oauth_callback') === '1') {
      if (params.get('error')) {
        if (caa.handlePkceCallbackError) {
          caa.handlePkceCallbackError({
            error: params.get('error'),
            error_description: params.get('error_description'),
            state: params.get('state')
          });
        }
        // An OAuth error= return describes THIS login attempt (the shopper
        // cancelled, or the IdP issued server_error, or the user-agent
        // returned access_denied). It says nothing about any existing
        // refresh token from a previous session — the most common case
        // being a shopper whose access token expired (REGISTER/LOGIN
        // re-shown), clicked Sign in, landed on Shopify, and cancelled.
        // clearTokensSafe() would destroy the refresh token that was
        // about to silently restore them — a permanent logout. Drop
        // only the active session (keep the refresh token) so the next
        // page load can still silently re-authenticate.
        clearSessionSafe();
        setCurrentCustomer(null);
        self.restoreModalState();
        self.cleanOAuthUrl();
        self.transition(self.preLoginFallbackState());
        return;
      }

      if (caa.handlePkceCallback && params.get('code') && params.get('state')) {
        caa.handlePkceCallback({
          code: params.get('code'),
          state: params.get('state'),
          shopDomain: self.getShopDomain(),
          clientId: window.HPQ_CAA_CLIENT_ID || '',
          redirectUri: self.getRedirectUri()
        }).then(function (tokens) {
          self.restoreModalState();
          // The token exchange succeeded — a refresh token is now stored.
          // The identity fetch that follows is a separate failure domain:
          // a transient CAA blip (5xx, network throw, mid-outage) must
          // not destroy the SESSION the exchange just created. Compare
          // the popup counterpart above, which catches getCustomerFromTokens
          // errors with clearSessionSafe() for the same reason.
          return caa.getCustomerFromTokens(tokens.idToken, tokens.accessToken, self.getShopDomain()).catch(function (err) {
            try { console.warn('[HPQ-FORTUNE] redirect customer fetch failed', err); } catch (e) {}
            // Transient identity-fetch failure — keep the refresh token.
            clearSessionSafe();
            setCurrentCustomer(null);
            self.restoreModalState();
            self.cleanOAuthUrl();
            self.transition(self.preLoginFallbackState());
            // Returning undefined here signals the next .then() to skip the
            // success path; the cleanup above already rendered the fallback.
            return null;
          });
        }).then(function (customer) {
          if (!customer) return; // identity-fetch catch already handled the UI
          setCurrentCustomer(customer);
          self.cleanOAuthUrl();
          // Restore the user's pre-login pathname from sessionStorage
          var returnPath = null;
          try { returnPath = window.sessionStorage.getItem('hpq:pkce-return-path'); } catch (e) {}
          if (returnPath && returnPath !== '/' && returnPath !== window.location.pathname) {
            // Use history.replaceState so we don't break the modal state — keep us
            // on the current document but update the URL to where the user came from
            try {
              var url = new URL(returnPath, window.location.origin);
              window.history.replaceState({}, '', url.toString());
              try { window.sessionStorage.removeItem('hpq:pkce-return-path'); } catch (e) {}
            } catch (e) {
              // Malformed path — leave sessionStorage entry for retry on next navigation.
            }
          }
          self.transition('recognizing');
        }).catch(function (err) {
          // Token exchange failed (network throw, discovery failure, 5xx on
          // the token endpoint). The exchange is itself transient for those
          // cases — keep any pre-existing refresh token so the next page
          // load, or a retry, can succeed. We do NOT call clearTokensSafe()
          // here: it would destroy the very refresh token the silent-refresh
          // path needs to silently re-authenticate.
          try { console.warn('[HPQ-FORTUNE] PKCE callback failed', err); } catch (e) {}
          clearSessionSafe();
          setCurrentCustomer(null);
          self.restoreModalState();
          self.cleanOAuthUrl();
          self.transition(self.preLoginFallbackState());
        });
        return;
      }
    }

    var tokens = getCachedTokensSafe();
    if (tokens && caa.getCustomerFromTokens) {
      caa.getCustomerFromTokens(tokens.idToken, tokens.accessToken, self.getShopDomain()).then(function (customer) {
        setCurrentCustomer(customer);
        self.transition('recognizing');
      }).catch(function () {
        clearSessionSafe(); // transient customer-fetch failure — keep refresh token
        setCurrentCustomer(null);
        self.transition('envelope_shake');
      });
      return;
    }

    var existing = loadSession();
    if (existing && hasActiveState(existing)) {
      var current = getCurrentCustomer();
      if (!current && existing.customer_gid || (current && current.gid !== existing.customer_gid)) {
        localStorage.removeItem(LS_KEY);
        this.session = { phone: null, email: null, has_active_state: false };
      } else {
        this.session = existing;
        this.resume(existing);
        return;
      }
    }

    if (existing && existing.fortune_line && !existing.customer_gid) {
      this.session = existing;
      this.transition('code_reveal');
      return;
    }

    this.transition('envelope_shake');
  };

  FortuneController.prototype.resume = function (stored) {
    var self = this;
    client.recognize().then(function (res) {
      if (res && res.ok === false) {
        try { localStorage.removeItem(LS_KEY); } catch (e) {}
        self.transition('envelope_shake');
        return;
      }
      var projection = res.serverProjection || {};
      var returnState = (projection.return_state) || 'new_user';
      self.routeFromReturnState(returnState, projection, res.customerIdentity);
    });
  };

  FortuneController.prototype.transition = function (state, data) {
    if (this.state === 'envelope_shake') this.detachShakeHandlers();
    if (this._history && this.state !== state) this._history.push(this.state);
    this.state = state;
    this.transitionPayload = data || null;
    this.section.setAttribute('data-state', state);
    this.session = this.session || {};
    this.session.state = state;
    this.save();
    this.render(state);
    var focusEl = this.inner && this.inner.querySelector('input, button, [tabindex]');
    if (focusEl) focusEl.focus();
  };

  FortuneController.prototype.save = function () { saveSession(this.session); };

  FortuneController.prototype.hydrateSession = function (projection, customerIdentity) {
    if (!projection) return;
    var s = this.session || {};
    Object.keys(projection).forEach(function (key) {
      if (key !== legacySessionKey() && projection[key] !== undefined) s[key] = projection[key];
    });
    if (projection[legacySessionKey()] && s.has_active_state === undefined) s.has_active_state = true;
    var customer = getCurrentCustomer();
    if (customer) {
      if (customer.email) s.email = customer.email;
      if (customer.firstName) s.first_name = customer.firstName;
      if (customer.gid) s.customer_gid = customer.gid;
    }
    if (projection.reward && projection.reward.code) {
      s.fortune = normalizeRewardForReveal(projection.reward, { tier_id: projection.tier_id });
    }
    this.session = migrateLocalStorageSchema(s) || s;
    if (customerIdentity) { this.session.customerIdentity = customerIdentity; }
    this.save();
  };

  FortuneController.prototype.routeFromReturnState = function (returnState, projection, customerIdentity) {
    this.hydrateSession(projection, customerIdentity);
    switch (returnState) {
      case 'code_reveal_standard':
        this.transition('code_reveal_standard');
        return;
      case 'code_reveal':
        this.transition('code_reveal');
        return;
      case 'code_reveal_pending':
        this.transition('code_reveal_pending');
        return;
      case 'declined':
        this.transition('phone_capture', { reason: 'declined' });
        return;
      case 'awaiting_sms_yes':
        this.transition('phone_capture', { reason: 'awaiting_sms_yes' });
        return;
      case 'phone_entry':
        this.transition('phone_capture');
        return;
      case 'phone_otp_pending':
        this.transition('otp_entry');
        return;
      case 'phone_verified_post_otp':
        this.transition('code_reveal_pending');
        return;
      case 'tier_upgrade':
        this.transition('tier_upgrade', { serverProjection: projection, customerIdentity: customerIdentity });
        return;
      case 'new_user':
      default:
        if (customerIdentity && customerIdentity.has_phone && customerIdentity.phone_verified) {
          this.transition('code_reveal_pending');
        } else {
          this.transition('phone_capture');
        }
        return;
    }
  };

  FortuneController.prototype.goBack = function () {
    if (!this._history || this._history.length === 0) return;
    var prev = this._history.pop();
    this.state = prev;
    this.section.setAttribute('data-state', prev);
    this.render(prev);
    this.save();
  };

  FortuneController.prototype.mountTurnstileForState = function (stateName, containerEl) {
    var self = this;
    var host = (window.location && window.location.hostname) || '';
    if (((host === 'localhost' || host === '127.0.0.1') && window.HPQ_FORTUNE_USE_DEV_WORKER === true) || host === 'hpq-dev.pelian.com') return;
    loadTurnstile().then(function () {
      if (!window.turnstile || !containerEl) return;
      var sitekey = window.HPQ_FORTUNE_TURNSTILE_SITE_KEY || '0x4AAAAAAC-MjEjBdbYq3IUq';
      var widgetId = window.turnstile.render(containerEl, {
        sitekey: sitekey,
        size: 'invisible',
        callback: function () { self.turnstileWidgets[stateName] = widgetId; },
        'expired-callback': function () {
          if (window.turnstile && self.turnstileWidgets[stateName]) window.turnstile.reset(self.turnstileWidgets[stateName]);
        },
        'error-callback': function (err) {
          self.turnstileLastError = { state: stateName, err: String(err) };
        }
      });
      self.turnstileWidgets[stateName] = widgetId;
      try { window.turnstile.execute(widgetId); } catch (e) {}
    });
  };

  FortuneController.prototype.render = function (state) {
    if (!this.inner) return;
    if (state === 'envelope_shake') return this.renderEnvelopeShake();
    if (state === 'recognizing') return this.renderRecognizing();
    if (state === 'tier_upgrade') return this.renderTierUpgrade(this.transitionPayload);
    if (state === 'identity_decision') return this.renderIdentityDecision();
    if (state === 'phone_capture') return this.renderPhoneEntry(this.transitionPayload);
    if (state === 'otp_entry') return this.renderOtpEntry(this.transitionPayload);
    if (state === 'code_reveal' || state === 'code_reveal_standard') return this.renderCodeReveal();
    if (state === 'code_reveal_pending') return this.renderCodeRevealPending();
    if (state === 'done') return this.renderDone();
  };

  FortuneController.prototype._clearPhoneVerifyTimers = function () {
    if (this._phoneVerifyTimers) {
      this._phoneVerifyTimers.forEach(function (id) { clearInterval(id); clearTimeout(id); });
      this._phoneVerifyTimers = [];
    }
  };

  FortuneController.prototype.renderEnvelopeShake = function () {
    var sess = this.session || {};
    if (sess.completed) return this.renderCodeReveal();
    if (!getCurrentCustomer() && !sess.fortune && !hasActiveState(sess)) return this.renderAnonymousEnvelope();
    if (sess.fortune || sess.phone_confirmed) return this.renderProgressEnvelope();
    this.renderAuthenticatedEnvelope();
  };

  FortuneController.prototype.renderProgressEnvelope = function () {
    var self = this;
    var h = this.inner;
    var sess = this.session || {};
    var hasFortune = !!sess.fortune;
    h.innerHTML =
      '<div class="hpq-fortune-shake hpq-fortune-shake--resume">' +
        '<div class="hpq-fortune-shake__eyebrow">Welcome back.</div>' +
        '<div class="hpq-fortune-shake__target">' +
          '<div class="hpq-fortune-shake__envelope hpq-fortune-shake__envelope--opened">📬</div>' +
        '</div>' +
        '<h2 class="hpq-fortune-shake__title">' + (hasFortune ? 'Your fortune is ready.' : 'Unlocked.') + '</h2>' +
        '<p class="hpq-fortune-shake__subtitle">Pick up where you left off. Auntie remembers.</p>' +
        '<button class="hpq-fortune-cta" data-action="resume-continue">Continue →</button>' +
      '</div>';
    h.querySelector('[data-action="resume-continue"]').addEventListener('click', function () {
      self.transition(hasFortune ? 'code_reveal' : 'phone_capture', sess.fortune || {});
    });
  };

  FortuneController.prototype.renderAnonymousEnvelope = function () {
    var h = this.inner;
    h.innerHTML =
      '<div class="hpq-fortune-shake" data-hpq-shake>' +
        '<div class="hpq-fortune-shake__eyebrow">Auntie can read the steam first.</div>' +
        '<div class="hpq-fortune-shake__target" data-hpq-shake-target>' +
          '<div class="hpq-fortune-shake__envelope">🧧</div>' +
        '</div>' +
        '<h2 class="hpq-fortune-shake__title">Shake for<br>Your Fortune</h2>' +
        '<p class="hpq-fortune-shake__subtitle">Shake your phone — or tap the envelope.<br>One draw per day.</p>' +
        '<div class="hpq-fortune-shake__meter">' +
          '<div class="hpq-fortune-shake__dot" data-hpq-dot="1"></div>' +
          '<div class="hpq-fortune-shake__dot" data-hpq-dot="2"></div>' +
          '<div class="hpq-fortune-shake__dot" data-hpq-dot="3"></div>' +
        '</div>' +
      '</div>';
    this.attachShakeHandlers();
  };

  FortuneController.prototype.renderIdentityDecision = function () {
    var self = this;
    var h = this.inner;
    var customer = getCurrentCustomer();
    var sess = this.session || {};

    if (customer) {
      // ── Recognized variant ─────────────────────────────────────────────
      var firstName = (customer.firstName || customer.first_name || '').trim();
      h.innerHTML =
        '<div class="hpq-fortune-identity hpq-fortune-identity--recognized" data-modal-id="identity_decision•returning-user">' +
          '<div class="hpq-fortune-shake__eyebrow">Auntie remembers.</div>' +
          '<p class="hpq-fortune-identity__greeting">Logged in as <strong>' + escHTML(firstName || 'you') + '</strong>.</p>' +
          '<p class="hpq-fortune-identity__subtitle">Today\'s fortune is ready when you are.</p>' +
          '<button class="hpq-fortune-cta" id="hpq-identity-reveal">Reveal Code</button>' +
          '<button class="hpq-fortune-identity__notyou" id="hpq-identity-notyou">Not you? Sign in as someone else.</button>' +
        '</div>';
      h.querySelector('#hpq-identity-reveal').addEventListener('click', function () {
        // Dispatch to whatever post-recognize state should render next based on session
        var rs = sess.return_state || 'new_user';
        var projection = Object.assign({}, sess, { has_active_state: !!sess.has_active_state });
        self.routeFromReturnState(rs, projection);
      });
      h.querySelector('#hpq-identity-notyou').addEventListener('click', function () {
        if (self.section && self.section.getAttribute('data-hpq-logout-pending') === 'true') return;
        // Full Shopify session termination via OIDC end_session_endpoint with
        // id_token_hint (skips interstitial) + post_logout_redirect_uri (returns
        // user to current page in anonymous state). See memory
        // reference_shopify_caa_login_logout_bridge.md for canonical pattern.
        function setLogoutPending(pending) {
          var root = self.section;
          if (!root) return;
          if (pending) {
            ensureLogoutPendingStyles();
            root.setAttribute('data-hpq-logout-pending', 'true');
            root.classList.add('hpq-fortune--logging-out');
          } else {
            root.removeAttribute('data-hpq-logout-pending');
            root.classList.remove('hpq-fortune--logging-out');
          }
          var controls = h.querySelectorAll('button');
          for (var i = 0; i < controls.length; i++) {
            controls[i].disabled = pending;
            controls[i].setAttribute('aria-disabled', pending ? 'true' : 'false');
          }
        }
        function fallbackAfterLogoutFailure() {
          setLogoutPending(false);
          window.location.href = window.location.origin + window.location.pathname;
        }

        setLogoutPending(true);
        try { setCurrentCustomer(null); } catch (e) {}
        caa.logout({
          shopDomain: self.getShopDomain(),
          postLogoutRedirectUri: window.location.origin + window.location.pathname
        }).then(function (result) {
          if (result && result.ok === false) {
            fallbackAfterLogoutFailure();
          } else {
            setLogoutPending(false);
          }
        }).catch(function () {
          // logout helper already cleared local tokens; if discovery failed,
          // fall back to local navigation (anonymous state preserved)
          fallbackAfterLogoutFailure();
        });
      });
    } else {
      // ── Anonymous variant ──────────────────────────────────────────────
      h.innerHTML =
        '<div class="hpq-fortune-identity hpq-fortune-identity--anonymous">' +
          '<div class="hpq-fortune-shake__eyebrow">Auntie\'s curious.</div>' +
          '<p class="hpq-fortune-identity__greeting">Who\'s here today?</p>' +
          '<p class="hpq-fortune-identity__subtitle">Sign in to claim your coupon, or skip and read your fortune.</p>' +
          '<button class="hpq-fortune-cta" id="hpq-identity-login">Sign in</button>' +
          '<button class="hpq-fortune-cta hpq-fortune-cta--secondary" id="hpq-identity-signup">New here? Sign up</button>' +
          '<button class="hpq-fortune-identity__skip" id="hpq-identity-skip">I only pay full price</button>' +
        '</div>';
      h.querySelector('#hpq-identity-login').addEventListener('click', function () {
        crackCookie(self.inner);
        // Call synchronously (no setTimeout): the popup path's window.open must
        // run inside this click gesture or a strict popup blocker rejects it.
        self.beginPkceFlow();
      });
      h.querySelector('#hpq-identity-signup').addEventListener('click', function () {
        crackCookie(self.inner);
        // TODO(fortune-pkce-signup): pass { signup: true } when beginPkceFlow supports opts
        // Synchronous for the same in-gesture window.open reason as above.
        self.beginPkceFlow();
      });
      h.querySelector('#hpq-identity-skip').addEventListener('click', function () {
        self.transition('code_reveal');
      });
    }
  };

  FortuneController.prototype.renderAuthenticatedEnvelope = function () {
    var h = this.inner;
    var sess = this.session || {};
    var isReturn = !!sess.is_return_customer;
    h.innerHTML =
      '<div class="hpq-fortune-shake" data-hpq-shake>' +
        '<div class="hpq-fortune-shake__eyebrow">' +
          escHTML(isReturn ? 'Welcome back. Auntie decided to boost your fortune today.' : 'Everyone wins. Up to 30% off.') +
        '</div>' +
        '<div class="hpq-fortune-shake__target" data-hpq-shake-target>' +
          '<div class="hpq-fortune-shake__envelope">🧧</div>' +
        '</div>' +
        '<h2 class="hpq-fortune-shake__title">Shake for<br>Your Fortune</h2>' +
        '<p class="hpq-fortune-shake__subtitle">Shake your phone — or tap the envelope.<br>One draw per day.</p>' +
        '<div class="hpq-fortune-shake__meter">' +
          '<div class="hpq-fortune-shake__dot" data-hpq-dot="1"></div>' +
          '<div class="hpq-fortune-shake__dot" data-hpq-dot="2"></div>' +
          '<div class="hpq-fortune-shake__dot" data-hpq-dot="3"></div>' +
        '</div>' +
      '</div>';
    this.attachShakeHandlers();
  };

  FortuneController.prototype.renderRecognizing = function () {
    var self = this;
    var h = this.inner;
    var customer = getCurrentCustomer();
    var firstName = (customer && customer.firstName) || '';
    h.innerHTML =
      '<div class="hpq-fortune-recognizing">' +
        '<p class="hpq-fortune-footer__heading">' + (firstName ? 'Welcome back, ' + escHTML(firstName) + '.' : 'Welcome back.') + '</p>' +
        '<p class="hpq-fortune-footer__body">Auntie is checking her notes...</p>' +
        '<div class="hpq-fortune-recognizing__spinner" aria-hidden="true"></div>' +
      '</div>';
    client.recognize().then(function (res) {
      if (res.ok === false) {
        console.error('[HPQ-FORTUNE] recognize bounce → envelope_shake; reason=', res.reason, 'message=', res.message);
        setCurrentCustomer(null);
        clearSessionSafe(); // recognize bounce is not an auth failure — keep refresh token
        self.transition('envelope_shake');
        return;
      }
      var projection = res.serverProjection || {};
      self.routeFromReturnState((projection.return_state) || 'new_user', projection, res.customerIdentity);
    }).catch(function (err) {
      console.error('[HPQ-FORTUNE] recognize threw → envelope_shake;', err && (err.message || err));
      setCurrentCustomer(null);
      clearSessionSafe(); // transient recognize failure — keep refresh token
      self.transition('envelope_shake');
    });
  };

  FortuneController.prototype.renderTierUpgrade = function (payload) {
    var self = this;
    var h = this.inner;
    payload = payload || {};

    var sp = (payload && payload.serverProjection) || {};
    var priorTier = (sp.prior_tier || 'BRONZE').toUpperCase();
    var newTier   = (sp.new_tier   || 'SILVER').toUpperCase();

    var TIER_PCTS = { BRONZE: 8, SILVER: 15, GOLD: 30 };
    var priorPct = TIER_PCTS[priorTier] || 8;
    var newPct   = TIER_PCTS[newTier]   || 15;
    var priorLabel = priorTier + ' TIER';
    var newLabel   = newTier + ' TIER';
    var heading = 'WELCOME TO ' + newTier + ' TIER';
    var subhead = (priorTier === 'BRONZE' && newTier === 'SILVER')
      ? 'You came back. You ordered. That counts. Auntie keeps track of these things.'
      : 'Phone unlocked. The good stuff.';

    // Tier-specific colors live in custom.css keyed on .hpq-fortune-tier-upgrade--<tier>
    // — see "Tier upgrade modal" section.
    h.innerHTML =
      '<div class="hpq-fortune-tier-upgrade hpq-fortune-tier-upgrade--' + newTier.toLowerCase() + '" data-modal-id="tier_upgrade•' + newTier.toLowerCase() + '">' +
        '<p class="hpq-fortune-shake__eyebrow">Auntie noticed.</p>' +
        '<p class="hpq-fortune-pc__perks-header hpq-fortune-tier-upgrade__heading">' + escHTML(heading) + '</p>' +
        '<p class="hpq-fortune-footer__body hpq-fortune-tier-upgrade__subhead">' + escHTML(subhead) + '</p>' +
        '<div class="hpq-fortune-pc__perks-card hpq-fortune-tier-upgrade__perks-card">' +
          '<div class="hpq-fortune-pc__tier-reveal">' +
            '<div class="hpq-fortune-pc__tier-stat hpq-fortune-pc__tier-stat--current">' +
              '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--upto">UP TO</span>' +
              '<span class="hpq-fortune-pc__tier-pct">' + priorPct + '% OFF</span>' +
              '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--name">' + escHTML(priorLabel) + '</span>' +
              '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--tag">(CURRENT)</span>' +
            '</div>' +
            '<div class="hpq-fortune-pc__tier-arrow"></div>' +
            '<div class="hpq-fortune-pc__tier-stat hpq-fortune-pc__tier-stat--new">' +
              '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--upto">UP TO</span>' +
              '<span class="hpq-fortune-pc__tier-pct">' + newPct + '% OFF</span>' +
              '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--name">' + escHTML(newLabel) + '</span>' +
              '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--tag hpq-fortune-pc__tier-row--top-tag">(NEW)</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<p class="hpq-fortune-footer__msg" id="hpq-fortune-upgrade-error" aria-live="polite"></p>' +
        '<button class="hpq-fortune-cta hpq-fortune-tier-upgrade__cta" id="hpq-fortune-upgrade-cta">Continue to your fortune</button>' +
      '</div>';

    var ctaBtn = h.querySelector('#hpq-fortune-upgrade-cta');
    var errEl  = h.querySelector('#hpq-fortune-upgrade-error');
    var newTierForAck = self.session && self.session.pending_upgrade_tier ? self.session.pending_upgrade_tier : sp.new_tier;
    var returnState   = sp.next_return_state || 'new_user';
    var projection    = Object.assign({}, sp, { return_state: returnState });

    ctaBtn.addEventListener('click', function () {
      ctaBtn.disabled = true;
      ctaBtn.setAttribute('aria-disabled', 'true');
      client.tierUpgradeAck(newTierForAck).then(function (r) {
        if (r && r.ok === false) {
          ctaBtn.disabled = false;
          ctaBtn.setAttribute('aria-disabled', 'false');
          if (errEl) errEl.textContent = r.message || AUNTIE_COPY.generic_failure;
          return;
        }
        self.routeFromReturnState(returnState, projection, payload.customerIdentity);
      }).catch(function () {
        ctaBtn.disabled = false;
        ctaBtn.setAttribute('aria-disabled', 'false');
        if (errEl) errEl.textContent = AUNTIE_COPY.generic_failure;
      });
    });
  };

  FortuneController.prototype.renderPhoneEntry = function (payload) {
    var self = this;
    var h = this.inner;
    payload = payload || {};
    self._clearPhoneVerifyTimers();

    var _locPC = (function () {
      try { return window.theme.strings.fortune.phone_capture || {}; } catch (e) { return {}; }
    }());
    function loc(key, fallback) {
      return (_locPC && _locPC[key]) || fallback;
    }

    var identityTier = (this.session && this.session.customerIdentity && this.session.customerIdentity.tier) || null;
    var tier = (payload.tier || identityTier || 'BRONZE').toUpperCase();
    if (tier !== 'BRONZE' && tier !== 'SILVER') tier = 'BRONZE';
    var currentMax = tier === 'BRONZE' ? 8 : 15;
    var goldMax = 30;
    var currentLabel = tier === 'BRONZE'
      ? loc('tier_reveal_label_bronze', 'BRONZE TIER')
      : loc('tier_reveal_label_silver', 'SILVER TIER');
    var upToLabel  = loc('tier_reveal_upto', 'UP TO');
    var currentTag = loc('tier_reveal_current_tag', '(CURRENT)');
    var goldLabel  = loc('tier_reveal_label_gold', 'GOLD TIER');
    var goldTag    = loc('tier_reveal_top_tag', '(TOP)');

    var heading      = loc('heading',      'UNLOCK GOLD TIER');
    var subhead      = loc('subhead',      'Auntie wants to save you even more.');
    var perksHeader  = loc('perks_header', 'ENTER PHONE NUMBER');
    var disclosure   = loc('disclosure',   'By verifying your phone number, you agree to receive SMS marketing messages from Hotpot Queen. Message and data rates may apply. Reply STOP to opt out.');
    var ctaPrimary   = loc('cta_primary',  'Verify my number');
    var ctaSkip      = loc('cta_skip',     'Skip — I save too much');

    // Autofill phone from CAA customer record when present-but-unverified.
    // CAA returns E.164; we re-format to NATIONAL display once libphonenumber loads.
    var existingPhoneE164 = (this.session && this.session.customerIdentity && this.session.customerIdentity.phoneNumber) || '';

    var tierRevealHTML =
      '<div class="hpq-fortune-pc__perks-card">' +
        '<p class="hpq-fortune-pc__perks-header">' + escHTML(perksHeader) + '</p>' +
        '<div class="hpq-fortune-pc__tier-reveal">' +
          '<div class="hpq-fortune-pc__tier-stat hpq-fortune-pc__tier-stat--current">' +
            '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--upto">' + escHTML(upToLabel) + '</span>' +
            '<span class="hpq-fortune-pc__tier-pct">' + currentMax + '% OFF</span>' +
            '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--name">' + escHTML(currentLabel) + '</span>' +
            '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--tag">' + escHTML(currentTag) + '</span>' +
          '</div>' +
          '<div class="hpq-fortune-pc__tier-arrow"></div>' +
          '<div class="hpq-fortune-pc__tier-stat hpq-fortune-pc__tier-stat--gold">' +
            '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--upto">' + escHTML(upToLabel) + '</span>' +
            '<span class="hpq-fortune-pc__tier-pct">' + goldMax + '% OFF</span>' +
            '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--name hpq-fortune-pc__tier-label--gold">' + escHTML(goldLabel) + '</span>' +
            '<span class="hpq-fortune-pc__tier-row hpq-fortune-pc__tier-row--tag hpq-fortune-pc__tier-row--top-tag">' + escHTML(goldTag) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    var phoneFieldHTML =
      '<div class="hpq-fortune-pc__phone-field">' +
        '<label class="hpq-fortune-pc__country" aria-label="Country">' +
          '<select id="hpq-fortune-country" class="hpq-fortune-pc__country-select">' +
            '<option value="US" selected>🇺🇸 US</option>' +
            '<option value="CA">🇨🇦 CA</option>' +
          '</select>' +
        '</label>' +
        '<span class="hpq-fortune-pc__phone-prefix" aria-hidden="true">+1</span>' +
        '<input type="tel" name="phone" id="hpq-fortune-phone-input" class="hpq-fortune-pc__phone-input" placeholder="(555) 555-5555" aria-describedby="hpq-fortune-phone-disclosure hpq-fortune-phone-error" autocomplete="tel-national" inputmode="numeric" maxlength="16">' +
      '</div>';

    h.innerHTML =
      '<p class="hpq-fortune-pc__heading">' + escHTML(heading) + '</p>' +
      '<p class="hpq-fortune-pc__subhead">' + escHTML(subhead) + '</p>' +
      tierRevealHTML +
      '<form class="hpq-fortune-footer__form" role="form" aria-label="Phone verification">' +
        phoneFieldHTML +
        '<p class="hpq-fortune-pc__disclosure" id="hpq-fortune-phone-disclosure">' +
          escHTML(disclosure) +
          ' <a href="/policies/sms-terms" target="_blank" rel="noopener">Terms</a>' +
        '</p>' +
        '<p class="hpq-fortune-footer__msg" id="hpq-fortune-phone-error" aria-live="polite"></p>' +
        '<button type="submit" class="hpq-fortune-pc__cta-primary hpq-fortune-cta--gold" id="hpq-fortune-submit" disabled aria-disabled="true">' +
          escHTML(ctaPrimary) +
        '</button>' +
      '</form>' +
      '<button type="button" class="hpq-fortune-pc__skip" data-action="skip">' + escHTML(ctaSkip) + '</button>';

    var form          = h.querySelector('form');
    var msgEl         = h.querySelector('#hpq-fortune-phone-error');
    var submitBtn     = h.querySelector('#hpq-fortune-submit');
    var phoneInp      = h.querySelector('#hpq-fortune-phone-input');
    var countrySelect = h.querySelector('#hpq-fortune-country');
    var skipBtn       = h.querySelector('.hpq-fortune-pc__skip');

    // Holds the resolved libphonenumber utils once loaded. Submit/validate path
    // tolerates this being null (falls back to regex normalization).
    var phoneUtils = null;

    function nationalDigits(input) {
      // Strip everything except digits, ignore a leading 1 (US/CA country code).
      var d = (input || '').replace(/\D/g, '');
      if (d.length > 10 && d.charAt(0) === '1') d = d.slice(1);
      return d.slice(0, 10);
    }

    function normalizeE164FromInput() {
      var country = (countrySelect && countrySelect.value) || 'US';
      var raw = phoneInp ? phoneInp.value : '';
      if (phoneUtils) {
        try {
          var e164 = phoneUtils.formatNumber(raw, country, phoneUtils.numberFormat.E164);
          if (e164 && e164.charAt(0) === '+') return e164;
        } catch (e) {}
      }
      // Fallback: regex-only normalization (US/CA assumption).
      var digits = nationalDigits(raw);
      return digits.length === 10 ? '+1' + digits : '';
    }

    function isValid() {
      var country = (countrySelect && countrySelect.value) || 'US';
      var raw = phoneInp ? phoneInp.value : '';
      if (phoneUtils) {
        try {
          return !!phoneUtils.isValidNumber(raw, country, ['MOBILE', 'FIXED_LINE_OR_MOBILE']);
        } catch (e) {}
      }
      // Fallback: 10 NANP digits.
      return nationalDigits(raw).length === 10;
    }

    function formatAsYouType() {
      if (!phoneUtils || !phoneInp) return;
      var country = (countrySelect && countrySelect.value) || 'US';
      var caretAtEnd = phoneInp.selectionStart === phoneInp.value.length;
      var raw = phoneInp.value;
      try {
        var formatted = phoneUtils.formatNumberAsYouType(raw, country);
        if (formatted && formatted !== raw) {
          phoneInp.value = formatted;
          if (caretAtEnd) phoneInp.setSelectionRange(formatted.length, formatted.length);
        }
      } catch (e) {}
    }

    function canSubmit() {
      var raw = phoneInp ? phoneInp.value.trim() : '';
      var ok = raw.length > 0 && isValid();
      if (msgEl) {
        msgEl.textContent = (raw.length > 3 && !ok) ? 'Enter a valid US or Canadian number.' : '';
      }
      // Invalid-only outer-border state: applied to the field container
      // after the user has typed enough that we can reasonably evaluate.
      // No green/valid styling — submit button being enabled is the positive cue.
      var fieldEl = h.querySelector('.hpq-fortune-pc__phone-field');
      if (fieldEl) {
        if (raw.length > 3 && !ok) fieldEl.classList.add('hpq-fortune-pc__phone-field--invalid');
        else fieldEl.classList.remove('hpq-fortune-pc__phone-field--invalid');
      }
      submitBtn.disabled = !ok;
      submitBtn.setAttribute('aria-disabled', submitBtn.disabled ? 'true' : 'false');
    }

    // Lazy-load libphonenumber, then prime autofill + handlers.
    getPhoneUtils().then(function (utils) {
      phoneUtils = utils;
      if (existingPhoneE164 && phoneInp && phoneUtils) {
        try {
          var national = phoneUtils.formatNumber(existingPhoneE164, 'US', phoneUtils.numberFormat.NATIONAL);
          if (national) phoneInp.value = national;
        } catch (e) {}
        formatAsYouType();
      } else if (existingPhoneE164 && phoneInp) {
        // No utils — fall back to raw E.164 in the field.
        phoneInp.value = existingPhoneE164;
      }
      canSubmit();
    });

    if (phoneInp) {
      phoneInp.addEventListener('input', function () {
        formatAsYouType();
        canSubmit();
      });
    }
    if (countrySelect) {
      countrySelect.addEventListener('change', function () {
        formatAsYouType();
        canSubmit();
      });
    }

    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        skipBtn.disabled = true;
        apiFetch('/phone-skip', { idempotency_nonce: generateIdempotencyNonceSafe() }).then(function (r) {
          if (r && r.ok && r.serverProjection) {
            self.routeFromReturnState(r.serverProjection.return_state, r.serverProjection, r.customerIdentity);
            return;
          }
          if (r && r.ok === false && (r.shouldReAuth || r.reason === 'caa_token_required')) {
            renderReAuthPane(h, self, r.message);
            return;
          }
          skipBtn.disabled = false;
          showMsg(h, (r && r.message) || AUNTIE_COPY.skip_failed);
        }).catch(function () {
          skipBtn.disabled = false;
          showMsg(h, AUNTIE_COPY.skip_failed);
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn.disabled) return;
      var ctaPrimaryText = submitBtn.textContent || submitBtn.innerText || ctaPrimary;
      var phone = normalizeE164FromInput();
      if (!phone) {
        showMsg(h, 'Enter a valid US or Canadian number.');
        return;
      }
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      msgEl.textContent = '';
      showWaitingMotion(h, 'dots');
      apiFetch('/phone-verify-start', {
        phone_e164: phone,
        consent_disclosure_shown: true,
        consent_button_label: ctaPrimaryText,
        idempotency_nonce: generateIdempotencyNonceSafe()
      }).then(function (r) {
        removeWaitingMotion(h);
        if (r && r.ok === false && (r.shouldReAuth || r.reason === 'caa_token_required')) {
          renderReAuthPane(h, self, r.message);
          return;
        }
        if (r && r.ok === false) {
          var code = r.reason;
          var msg = r.message || errorToAuntieCopy(code);
          showMsg(h, msg);
          submitBtn.disabled = false;
          submitBtn.setAttribute('aria-disabled', 'false');
          return;
        }
        if (r && r.ok === true) {
          if (r.skip_otp) {
            // Server confirmed phone_verified_at metafield is set — phone is
            // genuinely verified. Skip OTP screen and proceed directly to
            // tier-upgrade flow. r.already_yours alone (without skip_otp) means
            // the phone is on the customer's Shopify record but never
            // OTP-verified by us; that case must still pass through otp_entry.
            showMsg(h, 'This number is already verified on your account.');
            setTimeout(function () {
              if (!document.contains(h)) return;
              self.transition('code_reveal_pending');
            }, 1500);
            return;
          }
          self._pendingPhone = phone;
          self._pendingConsentLabel = ctaPrimaryText;
          self.transition('otp_entry');
        }
      }).catch(function () {
        removeWaitingMotion(h);
        submitBtn.disabled = false;
        submitBtn.setAttribute('aria-disabled', 'false');
        showMsg(h, AUNTIE_COPY.generic_failure);
      });
    });
  };

  FortuneController.prototype.renderOtpEntry = function (payload) {
    var self = this;
    var h = this.inner;
    payload = payload || {};

    var _locOTP = (function () {
      try { return window.theme.strings.fortune.otp_entry || {}; } catch (e) { return {}; }
    }());
    function loc(key, fallback) {
      return (_locOTP && _locOTP[key]) || fallback;
    }

    var heading     = loc('heading',     'Check your phone.');
    var subhead     = loc('subhead',     'Auntie sent a 6-digit code.');
    var ctaPrimary  = loc('cta_primary', 'Verify code');
    var ctaResend   = loc('cta_resend',  'Resend code');
    var expiryWarn  = loc('expiry_warn', 'Code expires in ');

    h.innerHTML =
      '<p class="hpq-fortune-pc__heading">' + escHTML(heading) + '</p>' +
      '<p class="hpq-fortune-pc__subhead">' + escHTML(subhead) + '</p>' +
      '<form class="hpq-fortune-footer__form" role="form" aria-label="OTP verification">' +
        '<div class="hpq-fortune-footer__field">' +
          '<input type="text" inputmode="numeric" pattern="\\d*" maxlength="6" name="otp" id="hpq-fortune-otp-input" class="hpq-fortune-footer__input" placeholder="000000" aria-describedby="hpq-fortune-otp-error hpq-fortune-otp-timer" autocomplete="one-time-code">' +
        '</div>' +
        '<p class="hpq-fortune-footer__msg" id="hpq-fortune-otp-error" aria-live="polite"></p>' +
        '<p class="hpq-fortune-pc__disclosure" id="hpq-fortune-otp-timer" aria-live="polite"></p>' +
        '<button type="submit" class="hpq-fortune-pc__cta-primary hpq-fortune-cta--gold" id="hpq-fortune-submit" disabled aria-disabled="true">' +
          escHTML(ctaPrimary) +
        '</button>' +
      '</form>' +
      '<button type="button" class="hpq-fortune-pc__skip" id="hpq-fortune-resend" disabled>' +
        escHTML(ctaResend) +
      '</button>' +
      '<button type="button" class="hpq-fortune-pc__skip" data-action="skip">' + escHTML(loc('cta_skip', 'Skip — just my fortune')) + '</button>';

    var form      = h.querySelector('form');
    var msgEl     = h.querySelector('#hpq-fortune-otp-error');
    var timerEl   = h.querySelector('#hpq-fortune-otp-timer');
    var submitBtn = h.querySelector('#hpq-fortune-submit');
    var otpInp    = h.querySelector('#hpq-fortune-otp-input');
    var resendBtn = h.querySelector('#hpq-fortune-resend');
    var skipBtn   = h.querySelector('[data-action="skip"]');

    function canSubmit() {
      var raw = otpInp ? otpInp.value.trim() : '';
      var ok = /^\d{6}$/.test(raw);
      submitBtn.disabled = !ok;
      submitBtn.setAttribute('aria-disabled', submitBtn.disabled ? 'true' : 'false');
    }

    if (otpInp) otpInp.addEventListener('input', canSubmit);

    // 60-second resend cooldown
    var resendCooldown = 60;
    var resendRemaining = resendCooldown;
    resendBtn.textContent = escHTML(ctaResend) + ' (' + resendRemaining + 's)';
    var resendInterval = setInterval(function () {
      if (!document.contains(h)) { clearInterval(resendInterval); return; }
      resendRemaining -= 1;
      if (resendRemaining <= 0) {
        clearInterval(resendInterval);
        resendBtn.disabled = false;
        resendBtn.textContent = escHTML(ctaResend);
      } else {
        resendBtn.textContent = escHTML(ctaResend) + ' (' + resendRemaining + 's)';
      }
    }, 1000);
    if (!self._phoneVerifyTimers) self._phoneVerifyTimers = [];
    self._phoneVerifyTimers.push(resendInterval);

    // 10-minute OTP expiry display
    var expirySeconds = 600;
    var expiryInterval = setInterval(function () {
      if (!document.contains(h)) { clearInterval(expiryInterval); return; }
      expirySeconds -= 1;
      if (expirySeconds <= 0) {
        clearInterval(expiryInterval);
        if (timerEl) timerEl.textContent = 'Code expired. Tap Resend code for a new one.';
      } else {
        var m = Math.floor(expirySeconds / 60);
        var s = expirySeconds % 60;
        if (timerEl) timerEl.textContent = escHTML(expiryWarn) + m + ':' + (s < 10 ? '0' : '') + s;
      }
    }, 1000);
    self._phoneVerifyTimers.push(expiryInterval);

    if (resendBtn) {
      resendBtn.addEventListener('click', function () {
        if (resendBtn.disabled) return;
        resendBtn.disabled = true;
        msgEl.textContent = '';
        showWaitingMotion(h, 'dots');
        var phone = self._pendingPhone || '';
        var label = self._pendingConsentLabel || ctaPrimary;
        apiFetch('/phone-verify-start', {
          phone_e164: phone,
          consent_disclosure_shown: true,
          consent_button_label: label,
          idempotency_nonce: generateIdempotencyNonceSafe()
        }).then(function (r) {
          removeWaitingMotion(h);
          if (r && r.ok === false && (r.shouldReAuth || r.reason === 'caa_token_required')) {
            renderReAuthPane(h, self, r.message);
            return;
          }
          if (r && r.ok === false) {
            var code = r.reason;
            var msg = r.message || errorToAuntieCopy(code);
            showMsg(h, msg);
            return;
          }
          if (r && r.ok === true) {
            // Restart cooldown
            resendRemaining = resendCooldown;
            resendBtn.disabled = true;
            resendBtn.textContent = escHTML(ctaResend) + ' (' + resendRemaining + 's)';
            var newInterval = setInterval(function () {
              if (!document.contains(h)) { clearInterval(newInterval); return; }
              resendRemaining -= 1;
              if (resendRemaining <= 0) {
                clearInterval(newInterval);
                resendBtn.disabled = false;
                resendBtn.textContent = escHTML(ctaResend);
              } else {
                resendBtn.textContent = escHTML(ctaResend) + ' (' + resendRemaining + 's)';
              }
            }, 1000);
            self._phoneVerifyTimers.push(newInterval);
            if (otpInp) otpInp.value = '';
            canSubmit();
            expirySeconds = 600;
            showMsg(h, 'A new code was sent.');
          }
        }).catch(function () {
          removeWaitingMotion(h);
          showMsg(h, AUNTIE_COPY.generic_failure);
        });
      });
    }

    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        skipBtn.disabled = true;
        apiFetch('/phone-skip', { idempotency_nonce: generateIdempotencyNonceSafe() }).then(function (r) {
          if (r && r.ok && r.serverProjection) {
            self.routeFromReturnState(r.serverProjection.return_state, r.serverProjection, r.customerIdentity);
            return;
          }
          if (r && r.ok === false && (r.shouldReAuth || r.reason === 'caa_token_required')) {
            renderReAuthPane(h, self, r.message);
            return;
          }
          skipBtn.disabled = false;
          showMsg(h, (r && r.message) || AUNTIE_COPY.skip_failed);
        }).catch(function () {
          skipBtn.disabled = false;
          showMsg(h, AUNTIE_COPY.skip_failed);
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn.disabled) return;
      var otp = otpInp ? otpInp.value.trim() : '';
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      msgEl.textContent = '';
      showWaitingMotion(h, 'dots');
      apiFetch('/phone-verify-confirm', {
        otp_code: otp,
        idempotency_nonce: generateIdempotencyNonceSafe()
      }).then(function (r) {
        removeWaitingMotion(h);
        if (r && r.ok === false && (r.shouldReAuth || r.reason === 'caa_token_required')) {
          renderReAuthPane(h, self, r.message);
          return;
        }
        if (r && r.ok === false) {
          var code = r.reason;
          var msg = r.message || errorToAuntieCopy(code);
          showMsg(h, msg);
          submitBtn.disabled = false;
          submitBtn.setAttribute('aria-disabled', 'false');
          return;
        }
        if (r && r.ok === true) {
          self._clearPhoneVerifyTimers();
          self.transition('code_reveal_pending');
        }
      }).catch(function () {
        removeWaitingMotion(h);
        submitBtn.disabled = false;
        submitBtn.setAttribute('aria-disabled', 'false');
        showMsg(h, AUNTIE_COPY.generic_failure);
      });
    });
  };

  FortuneController.prototype.bindCouponReveal = function (root, fortune, options) {
    options = options || {};
    var code = fortune.discount_code || '';
    var discountDisplay = discountDisplayForFortune(fortune);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    startExpiryCountdown(root, fortune.expires_at);

    var codeEl = root.querySelector('[data-role="code"]');
    var cardEl = root.querySelector('.hpq-fortune-footer__code-card');
    var copyBtn = root.querySelector('[data-role="copy-btn"]');
    var copyLabel = root.querySelector('[data-role="copy-label"]');
    var msgEl = root.querySelector('.hpq-fortune-footer__msg');
    var annEl = root.querySelector('[data-role="announce"]');
    if (!codeEl || !cardEl) return;

    function finalize() {
      codeEl.textContent = code;
      if (annEl) annEl.textContent = 'Hao. Your code is ready: ' + code;
      emit('fortune:claimed', { tier: fortune.tier || '', discount: discountDisplay, code_prefix: (code.split('-')[0] || '') });
      if (options.focus !== false && copyBtn) copyBtn.focus();
    }

    if (reducedMotion || !code) {
      finalize();
    } else {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var lockedCount = 0;
      var charCount = code.length;
      var msPerChar = Math.min(Math.max(Math.round(600 / (charCount || 1)), 60), 120);

      function scrambleTick() {
        var buf = '';
        for (var i = 0; i < charCount; i++) {
          if (i < lockedCount) {
            buf += code.charAt(i);
          } else {
            buf += chars[Math.floor(Math.random() * chars.length)];
          }
        }
        codeEl.textContent = buf;
      }

      var scrambleIntv = setInterval(function () {
        scrambleTick();
      }, 80);

      function lockNext() {
        if (lockedCount >= charCount) {
          clearInterval(scrambleIntv);
          finalize();
          return;
        }
        lockedCount++;
        if (lockedCount < charCount) {
          setTimeout(lockNext, msPerChar);
        } else {
          setTimeout(function () {
            clearInterval(scrambleIntv);
            finalize();
          }, msPerChar);
        }
      }

      setTimeout(lockNext, 200);
    }

    function doCopy() {
      if (!code) return;
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
        if (copyBtn) copyBtn.classList.add('hpq-fortune-footer__copy-btn--copied');
        if (copyLabel) copyLabel.textContent = 'Copied';
        setTimeout(function () {
          if (copyBtn) copyBtn.classList.remove('hpq-fortune-footer__copy-btn--copied');
          if (copyLabel) copyLabel.textContent = 'Copy';
        }, 1500);
        if (msgEl) msgEl.textContent = '';
      }).catch(function () { if (msgEl) msgEl.textContent = 'Copy failed — long-press the code to copy.'; });
    }

    // Remember the code CART-SIDE only — we deliberately no longer hit Shopify's
    // /discount/<CODE> endpoint. Applying it to the Shopify cart is exactly what let it
    // prefill at native checkout (the paste-at-checkout surface we're removing) and what
    // dropped the cart total below the free-ship line. Instead the draft-checkout module
    // hands the code to the worker, which applies it Shopify-side inside the draft and
    // forces free shipping when the pre-coupon subtotal already earned it — so the code
    // stays cart-only and the free-ship bar (pre-coupon) and checkout agree. The worker
    // enforces the $20 minimum + customer-scope; a refusal returns as hpq:draft-code-rejected.
    var MIN_SUBTOTAL_CENTS = 2000;

    function money(cents) {
      return '$' + (Math.max(0, cents) / 100).toFixed(2);
    }

    // Only used by the legacy (flag-off) apply path below.
    var FREE_SHIP_CENTS = (window.HPQ_CONFIG && window.HPQ_CONFIG.freeShippingThreshold) || 5900;

    function renderApplied() {
      var applyBtn = root.querySelector('[data-role="apply-btn"]');
      if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = 'Applied ✓'; }
      if (msgEl) msgEl.textContent = 'Locked in — applies automatically at checkout.';
      if (annEl) annEl.textContent = 'Discount will apply at checkout.';
      // A Remove affordance (injected once) is the shopper's escape hatch — clears the
      // cart-only code so checkout proceeds at the normal price. Lightly styled inline to
      // avoid a CSS round-trip; the theme can restyle .hpq-fortune-footer__remove-btn later.
      var status = (applyBtn && applyBtn.parentNode) || root.querySelector('.hpq-fortune-footer__status');
      if (status && !status.querySelector('[data-role="remove-btn"]')) {
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'hpq-fortune-footer__remove-btn';
        rm.setAttribute('data-role', 'remove-btn');
        rm.textContent = 'Remove';
        rm.style.cssText = 'background:none;border:none;padding:4px 0;margin-top:6px;' +
          'color:inherit;text-decoration:underline;cursor:pointer;font:inherit;opacity:.75;';
        rm.addEventListener('click', removeApplied);
        var msg = status.querySelector('.hpq-fortune-footer__msg');
        if (msg) status.insertBefore(rm, msg); else status.appendChild(rm);
      }
    }

    function removeApplied() {
      // The draft module owns coupon state; dispatching the removal (with this code) is what
      // detaches it from the array + sessionStorage. Don't touch the global directly.
      var applyBtn = root.querySelector('[data-role="apply-btn"]');
      if (applyBtn) { applyBtn.disabled = false; applyBtn.textContent = 'Apply to my cart'; }
      if (msgEl) msgEl.textContent = '';
      var rm = root.querySelector('[data-role="remove-btn"]');
      if (rm && rm.parentNode) rm.parentNode.removeChild(rm);
      document.dispatchEvent(new CustomEvent('hpq:coupon-removed', { detail: { code: code } }));
    }

    function draftCheckoutOn() {
      return (window.HPQ_CONFIG && window.HPQ_CONFIG.draftCheckoutEnabled === true) ||
        window.HPQ_FORCE_DRAFT_CHECKOUT === true;
    }

    // Legacy (flag-OFF / rollback) apply: push the code into the Shopify cart via
    // /discount/<CODE> exactly as before the draft-checkout flow existed, so turning the
    // flag off restores today's behavior byte-for-byte. Not used when the draft flow is on
    // (there the code must stay cart-only and never touch the Shopify cart session).
    function applyViaDiscountEndpoint(applyBtn) {
      function reset(label) {
        if (!applyBtn) return;
        applyBtn.disabled = false;
        applyBtn.textContent = label || 'Apply to my cart';
      }
      if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = 'Applying…'; }

      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', { credentials: 'include' })
        .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var apps = cart.cart_level_discount_applications || [];
          var applied = false;
          var want = code.toUpperCase();
          for (var i = 0; i < apps.length; i++) {
            if (String(apps[i].title || '').toUpperCase() === want ||
                String(apps[i].code || '').toUpperCase() === want) { applied = true; break; }
          }

          if (applied) {
            var lostFreeShip = cart.total_price < FREE_SHIP_CENTS;
            if (msgEl) {
              msgEl.textContent = lostFreeShip
                ? 'Applied. Note: your total is now below the ' + money(FREE_SHIP_CENTS) +
                  ' free-shipping line — add a little to earn free shipping too.'
                : 'Applied to your cart.';
            }
            if (annEl) annEl.textContent = 'Discount applied to your cart.';
            if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = 'Applied ✓'; }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            emit('fortune:applied_to_cart', { code_prefix: (code.split('-')[0] || '') });
            return;
          }

          if (!cart.item_count) {
            if (msgEl) msgEl.textContent = 'Add something to your cart first, then tap apply.';
          } else if (cart.total_price < MIN_SUBTOTAL_CENTS) {
            if (msgEl) {
              msgEl.textContent = 'Add ' + money(MIN_SUBTOTAL_CENTS - cart.total_price) +
                ' more to unlock your ' + discountDisplay + '% off.';
            }
          } else {
            if (msgEl) msgEl.textContent = 'Auntie could not apply it here — enter ' + code + ' at checkout.';
          }
          reset();
        })
        .catch(function () {
          if (msgEl) msgEl.textContent = 'Could not reach your cart — enter ' + code + ' at checkout.';
          reset();
        });
    }

    function doApply() {
      if (!code) return;
      var applyBtn = root.querySelector('[data-role="apply-btn"]');

      // Don't apply a dead code. The countdown computes expiry; past it the worker (or the
      // native cart) would reject it, so stop here with a clear message.
      var expMs = fortune.expires_at ? Date.parse(fortune.expires_at) : NaN;
      if (isFinite(expMs) && expMs <= Date.now()) {
        if (msgEl) msgEl.textContent = 'This code has expired — shake for a new one tomorrow.';
        if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = 'Expired'; }
        return;
      }

      // Flag OFF: preserve today's Shopify-cart apply so the flag is a true rollback switch.
      if (!draftCheckoutOn()) {
        applyViaDiscountEndpoint(applyBtn);
        return;
      }

      // Flag ON: cart-only. Client-side $20-minimum nudge (network-free) — Shopify evaluates
      // the minimum on the subtotal AFTER automatic volume discounts; hpqCart.getCart()
      // .total_price mirrors that (server-reconciled). The worker re-checks it at checkout.
      var cart = (window.hpqCart && typeof window.hpqCart.getCart === 'function') ? window.hpqCart.getCart() : null;
      if (cart && !cart.item_count) {
        if (msgEl) msgEl.textContent = 'Add something to your cart first, then tap apply.';
        return;
      }
      if (cart && cart.total_price != null && cart.total_price < MIN_SUBTOTAL_CENTS) {
        if (msgEl) {
          msgEl.textContent = 'Add ' + money(MIN_SUBTOTAL_CENTS - cart.total_price) +
            ' more to unlock your ' + discountDisplay + '% off.';
        }
        return;
      }

      // Remembered client-side, handed to the draft at checkout — never touches the Shopify
      // cart, so it can't prefill at native checkout. The draft module persists this to
      // sessionStorage (via the event below) so it survives navigation.
      var expForStore = isFinite(expMs) ? expMs : 0;
      // Draft module owns state via the event below; don't set the global directly (that
      // would desync the applied-codes array the cart coupon box renders from).
      // Capture the customer GID now, while they're definitely logged in (the coupon UI only
      // renders for a logged-in customer). getCachedCustomer() is in-memory and is usually
      // null on a freshly navigated /cart page before its async re-fetch lands, so storing the
      // GID with the code is what lets the worker match this customer-scoped code at checkout
      // instead of 422-ing on the common apply-then-navigate-then-checkout path.
      var custGid = '';
      try {
        var capiC = window.HPQCustomerAccountAPI;
        var cachedC = (capiC && typeof capiC.getCachedCustomer === 'function') ? capiC.getCachedCustomer() : null;
        custGid = (cachedC && cachedC.gid) || '';
      } catch (e) {}
      renderApplied();
      emit('fortune:applied_to_cart', { code_prefix: (code.split('-')[0] || '') });
      // The cart coupon box renders this as an applied chip; the draft module records it in
      // the applied-codes array + sessionStorage. This is the single source of truth.
      document.dispatchEvent(new CustomEvent('hpq:coupon-applied', {
        detail: { code: code, pct: discountDisplay, exp: expForStore, customerId: custGid }
      }));
    }

    // Reflect this reward's own applied state (e.g. the drawer re-rendered, or it was
    // rehydrated from sessionStorage after navigation) with "Applied ✓" instead of a fresh
    // "Apply" button. We only key on THIS code's membership in the applied set — other codes
    // in the cart (custom promos) are the cart coupon box's business, not the footer's.
    function fortuneCodeApplied() {
      try {
        if (window.hpqDraftCheckout && typeof window.hpqDraftCheckout.getCodes === 'function') {
          return window.hpqDraftCheckout.getCodes().indexOf(code) !== -1;
        }
      } catch (e) {}
      return !!(window.hpqAppliedCoupon && window.hpqAppliedCoupon.code === code);
    }
    if (fortuneCodeApplied()) renderApplied();

    if (copyBtn) copyBtn.addEventListener('click', doCopy);
    var applyBtnEl = root.querySelector('[data-role="apply-btn"]');
    if (applyBtnEl) applyBtnEl.addEventListener('click', doApply);
  };

  FortuneController.prototype.renderCodeReveal = function () {
    var self = this;
    var h = this.inner;
    var sess = self.session || {};
    var fortune = getRevealFortune(sess, self.transitionPayload);
    var canShowCoupon = !!(getCurrentCustomer() && fortune.discount_code);

    h.innerHTML =
      renderFortuneSlipHTML(sess, true) +
      (canShowCoupon ? renderCouponRevealHTML(fortune) : renderAnonCouponCTAHTML());

    if (canShowCoupon) {
      self.bindCouponReveal(h, fortune);
      return;
    }

    var claimBtn = h.querySelector('[data-action="claim-anon-coupon"]');
    if (claimBtn) {
      claimBtn.addEventListener('click', function () {
        claimBtn.disabled = true;
        claimBtn.setAttribute('aria-disabled', 'true');
        self.beginPkceFlow();
      });
    }
  };

  FortuneController.prototype.attachCouponToCrack = function (rewardData) {
    var slot = this.inner && this.inner.querySelector('[data-hpq-coupon-slot]');
    if (!slot) {
      this.renderCodeReveal();
      return;
    }

    var fortune = getRevealFortune(this.session || {}, rewardData);
    if (!fortune.discount_code) {
      showMsg(slot, 'Auntie could not find that coupon. Try again.');
      return;
    }

    ensureCouponAnimationStyles();
    slot.insertAdjacentHTML('afterend', renderCouponRevealHTML(fortune, 'hpq-coupon-animate-in'));
    var replacement = slot.nextElementSibling;
    slot.parentNode.removeChild(slot);
    this.bindCouponReveal(replacement || this.inner, fortune, { focus: true });
  };

  function renderReAuthPane(h, self, message) {
    h.innerHTML =
      '<p class="hpq-fortune-footer__heading">Auntie needs your sign-in again.</p>' +
      '<p>' + escHTML(message || errorToAuntieCopy('caa_token_required')) + '</p>' +
      '<p class="hpq-fortune-footer__msg" aria-live="polite"></p>' +
      '<button class="hpq-fortune-cta" data-action="signin">Sign in</button>';
    var signInBtn = h.querySelector('[data-action="signin"]');
    if (signInBtn) {
      signInBtn.addEventListener('click', function () { self.beginPkceFlow(); });
    }
  }

  FortuneController.prototype.renderCodeRevealPending = function () {
    var self = this;
    var h = this.inner;
    h.innerHTML =
      '<div class="hpq-fortune-recognizing">' +
        '<p class="hpq-fortune-footer__heading">Auntie is pulling your fortune...</p>' +
        '<div class="hpq-fortune-recognizing__spinner" aria-hidden="true"></div>' +
      '</div>';
    apiFetch('/code-reveal', { idempotency_nonce: generateIdempotencyNonceSafe() }).then(function (r) {
      if (r && r.ok === false && r.reason === 'declined') {
        self.transition('phone_capture', { reason: 'declined' });
        return;
      }
      if (r && r.ok === false && (r.shouldReAuth || r.reason === 'caa_token_required')) {
        renderReAuthPane(h, self, r.message);
        return;
      }
      if (r && r.ok === false) {
        h.innerHTML =
          '<p class="hpq-fortune-footer__heading">' + AUNTIE_COPY.code_reveal_pending_error_heading + '</p>' +
          '<p>' + escHTML(r.message || 'Give her a second and try again.') + '</p>' +
          '<button class="hpq-fortune-cta" data-action="retry">Try again</button>';
        h.querySelector('[data-action="retry"]').addEventListener('click', function () {
          self.transition('code_reveal_pending');
        });
        return;
      }
      if (r && r.serverProjection && r.serverProjection.return_state) {
        var projection = r.serverProjection || {};
        self.hydrateSession(projection, r.customerIdentity);
        storeFortuneLineFromResponse(self.session, r, false);
        self.routeFromReturnState(r.serverProjection.return_state, projection, r.customerIdentity);
        return;
      }
      h.innerHTML =
        '<p class="hpq-fortune-footer__heading">' + AUNTIE_COPY.code_reveal_pending_error_heading + '</p>' +
        '<p>Give her a second and try again.</p>' +
        '<button class="hpq-fortune-cta" data-action="retry">Try again</button>';
      h.querySelector('[data-action="retry"]').addEventListener('click', function () {
        self.transition('code_reveal_pending');
      });
    }).catch(function () {
      h.innerHTML =
        '<p class="hpq-fortune-footer__heading">' + AUNTIE_COPY.code_reveal_pending_error_heading + '</p>' +
        '<p>Give her a second and try again.</p>' +
        '<button class="hpq-fortune-cta" data-action="retry">Try again</button>';
      h.querySelector('[data-action="retry"]').addEventListener('click', function () {
        self.transition('code_reveal_pending');
      });
    });
  };

  FortuneController.prototype.renderDone = function () {
    var self = this;
    var h = this.inner;
    var hasSMS = !!(self.session && self.session.phone_confirmed);
    var doneBody = hasSMS ? 'Code in your texts. Go eat something.' : 'Go eat something.';
    h.innerHTML =
      '<p class="hpq-fortune-footer__heading">Okay. Now go.</p>' +
      '<p>' + escHTML(doneBody) + '</p>' +
      '<button class="hpq-fortune-cta" data-action="close">Close</button>';
    h.querySelector('[data-action="close"]').addEventListener('click', closeModal);
    if (self.session) {
      self.session.last_draw = 'today';
      self.save();
    }
  };

  var SHAKE_THRESHOLD = 20;
  var SHAKES_NEEDED = 3;

  FortuneController.prototype.attachShakeHandlers = function () {
    var self = this;
    this._shakeCount = 0;
    this._lastShakeTime = 0;
    var target = this.inner.querySelector('[data-hpq-shake-target]');
    if (!target) return;

    function haptic(ms) { if (navigator.vibrate) navigator.vibrate(ms); }
    function fillDot(n) {
      var dot = self.inner.querySelector('[data-hpq-dot="' + n + '"]');
      if (dot) dot.classList.add('hpq-fortune-shake__dot--filled');
    }
    function joltTarget() {
      target.classList.add('hpq-fortune-shake__target--shaking');
      setTimeout(function () { target.classList.remove('hpq-fortune-shake__target--shaking'); }, 200);
    }
    function onShake(fromMotion) {
      var now = Date.now();
      if (fromMotion && now - self._lastShakeTime < 300) return;
      self._lastShakeTime = now;
      self._shakeCount++;
      joltTarget();
      fillDot(self._shakeCount);
      if (self._shakeCount < SHAKES_NEEDED) {
        haptic(40);
        return;
      }
      haptic(100);
      setTimeout(function () {
        self.detachShakeHandlers();
        if (getCurrentCustomer()) {
          self.transition('recognizing');
        } else {
          crackCookie(self.inner);
          showWaitingMotion(self.inner, 'dots');
          client.shake().then(function (r) {
            removeWaitingMotion(self.inner);
            self.session = self.session || {};
            if (r && r.serverProjection) self.hydrateSession(r.serverProjection, r.customerIdentity);
            storeFortuneLineFromResponse(self.session, r, true);
            self.save();
            self.transition('code_reveal');
          }).catch(function () {
            removeWaitingMotion(self.inner);
            self.session = self.session || {};
            storeFortuneLineFromResponse(self.session, {}, true);
            self.save();
            self.transition('code_reveal');
          });
        }
      }, 400);
    }
    this._onTapFn = function () { onShake(false); };
    target.addEventListener('click', this._onTapFn);

    function startMotion() {
      self._onMotionFn = function (e) {
        var ag = e.accelerationIncludingGravity;
        if (!ag) return;
        var total = Math.abs(ag.x || 0) + Math.abs(ag.y || 0) + Math.abs(ag.z || 0);
        if (total > SHAKE_THRESHOLD) onShake(true);
      };
      window.addEventListener('devicemotion', self._onMotionFn);
    }

    if (typeof DeviceMotionEvent !== 'undefined' && typeof DeviceMotionEvent.requestPermission === 'function') {
      DeviceMotionEvent.requestPermission().then(function (result) {
        if (result === 'granted') startMotion();
      }).catch(function () {});
    } else {
      startMotion();
    }
  };

  FortuneController.prototype.detachShakeHandlers = function () {
    if (this._onMotionFn) {
      window.removeEventListener('devicemotion', this._onMotionFn);
      this._onMotionFn = null;
    }
    if (this._onTapFn) {
      var target = this.inner && this.inner.querySelector('[data-hpq-shake-target]');
      if (target) target.removeEventListener('click', this._onTapFn);
      this._onTapFn = null;
    }
  };

  function closeModal() {
    document.dispatchEvent(new CustomEvent('hpq:fortune-tab:close'));
  }

  function crackCookie(container) {
    var cookie = container && container.querySelector('.hpq-fortune-shake__envelope');
    if (cookie) {
      cookie.classList.add('hpq-fortune-shake__envelope--opened');
      cookie.textContent = '🥠';
    }
  }

  function showWaitingMotion(targetElement, mode) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wrapper = document.createElement('span');
    wrapper.setAttribute('data-hpq-waiting', '1');
    wrapper.setAttribute('aria-live', 'polite');
    if (reduced) {
      wrapper.textContent = 'Auntie is listening...';
    } else if (mode === 'breath') {
      wrapper.innerHTML =
        '<span class="hpq-waiting-breath" aria-hidden="true"></span>' +
        '<span class="hpq-sr-only">Auntie is listening...</span>';
    } else {
      wrapper.innerHTML =
        '<span class="hpq-waiting-dots" aria-hidden="true">' +
          '<span></span><span></span><span></span>' +
        '</span>' +
        '<span class="hpq-sr-only">Auntie is listening...</span>';
    }
    if (targetElement) targetElement.appendChild(wrapper);
    return wrapper;
  }

  function removeWaitingMotion(targetElement) {
    if (!targetElement) return;
    var existing = targetElement.querySelector('[data-hpq-waiting]');
    if (existing) existing.parentNode.removeChild(existing);
  }

  function showMsg(container, text) {
    var el = container && container.querySelector('.hpq-fortune-footer__msg');
    if (el) el.textContent = text;
  }

  // Drive the split-flap countdown to coupon expiry. Pure self-loop via
  // setTimeout — auto-cancels when the root node is detached (next render
  // tears down innerHTML, so document.contains() goes false on the next tick).
  function startExpiryCountdown(rootEl, expiresAtIso) {
    var wrap = rootEl.querySelector('[data-role="countdown"]');
    var aria = rootEl.querySelector('[data-role="countdown-aria"]');
    if (!wrap) return;

    var roles = ['hh1', 'hh2', 'mm1', 'mm2', 'ss1', 'ss2'];
    var tiles = {};
    for (var i = 0; i < roles.length; i++) {
      tiles[roles[i]] = wrap.querySelector('[data-role="' + roles[i] + '"]');
    }

    // Fall back to next midnight PT if expiry not provided (defense in depth;
    // worker R2 always provides expires_at, but legacy DO state could miss it).
    var expiresMs = expiresAtIso ? Date.parse(expiresAtIso) : NaN;
    if (!isFinite(expiresMs)) {
      var nowD = new Date();
      var ptStr = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      var ptNow = new Date(ptStr);
      var midnightPT = new Date(ptNow);
      midnightPT.setHours(24, 0, 0, 0);
      expiresMs = nowD.getTime() + (midnightPT.getTime() - ptNow.getTime());
    }

    function pad2(n) { return n < 10 ? '0' + n : '' + n; }

    function setTile(role, ch) {
      var el = tiles[role];
      if (!el) return;
      if (el.textContent === ch) return;
      el.textContent = ch;
      el.classList.remove('hpq-fortune-footer__count-tile--flip');
      // Re-trigger the flip by forcing a reflow before re-adding the class.
      void el.offsetWidth;
      el.classList.add('hpq-fortune-footer__count-tile--flip');
    }

    function tick() {
      if (!document.contains(wrap)) return; // detached -> stop
      var remainMs = expiresMs - Date.now();
      if (remainMs <= 0) {
        for (var k in tiles) if (tiles[k]) tiles[k].textContent = '0';
        if (aria) aria.textContent = 'Coupon expired.';
        wrap.classList.add('hpq-fortune-footer__countdown--expired');
        return;
      }
      var totalSec = Math.floor(remainMs / 1000);
      var hh = Math.floor(totalSec / 3600);
      var mm = Math.floor((totalSec % 3600) / 60);
      var ss = totalSec % 60;
      var hhStr = pad2(hh);
      var mmStr = pad2(mm);
      var ssStr = pad2(ss);
      setTile('hh1', hhStr.charAt(0));
      setTile('hh2', hhStr.charAt(1));
      setTile('mm1', mmStr.charAt(0));
      setTile('mm2', mmStr.charAt(1));
      setTile('ss1', ssStr.charAt(0));
      setTile('ss2', ssStr.charAt(1));
      // Update aria-label every minute to keep SR users informed without spam.
      if (aria && ss === 0) {
        aria.textContent = hh + ' hours, ' + mm + ' minutes remaining';
      }
      // Align next tick to the next 1s boundary to avoid drift.
      var msToNext = 1000 - (Date.now() % 1000);
      setTimeout(tick, msToNext);
    }
    tick();
  }

  function escHTML(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function mountFortuneFooter() {
    var target = document.querySelector('[data-hpq-fortune-mount]');
    if (!target) return;
    _fortuneController = new FortuneController(target);
    try {
      if (window.location && window.location.search.indexOf('hpq_debug=1') !== -1) {
        window._fortuneController = _fortuneController;
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountFortuneFooter);
  } else {
    mountFortuneFooter();
  }

  // bfcache restore: if the user clicked Sign in (beginPkceFlow ran, modal
  // swapped to the "Auntie's getting your name from Shopify" loader, page
  // redirected to Shopify CAA) and then hit browser back, the page is
  // restored from bfcache with the loader frozen in place. Detect this and
  // reset the modal to a re-attemptable state.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !_fortuneController) return;
    if (_fortuneController.section.querySelector('.hpq-fortune-shake--redirecting')) {
      _fortuneController.transition(_fortuneController.preLoginFallbackState());
    }
  });

  // Test-only handles for the plain-node vm harness (tests/*.mjs). Not part of
  // the storefront contract; the production code paths above do not read them.
  window.__hpqTestAuthHeaders = authHeaders;
  window.__hpqTestApiFetch = apiFetch;
})();
